<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      enable-resize-watcher
      fixed
      app
      class="grey darken-4"
    >
      <side-drawer></side-drawer>
    </v-navigation-drawer>
    <v-toolbar
      app
      color="primary"
      class="elevation-1"
    >
      <v-btn icon @click="goBack()" class="white--text">
        <v-icon>keyboard_arrow_left</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-toolbar-title class="white--text">{{ (salesOrderNo ? 'Edit Sales Order' : 'Create Sales Order') }}</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-content>
      <v-layout>
        <v-flex xs12>
          <v-card class="pa-4">
            <v-container fluid grid-list-xs class="pa-0">
              <v-layout row wrap>
                <v-flex xs12 v-if="salesOrderNo">
                  <v-container fluid grid-list-xs>
                    <v-layout row wrap>
                      <v-flex xs12 sm6 class="mb-3">
                        Sales Order
                        <h1 class="text-xs-left headline font-weight-bold">{{ salesOrderNo }}</h1>
                        <h3 class="text-xs-left body-2 font-weight-medium">{{ invoiceNo }}</h3>
                      </v-flex>
                      <v-flex xs12 sm6 class="mb-3 text-xs-left text-sm-right">
                      </v-flex>
                      <v-flex xs12>
                        <v-divider></v-divider>
                      </v-flex>
                      <v-flex xs12>
                        <v-container fluid grid-list-xs class="pt-3 pb-3 pl-2">
                          <v-layout row wrap>
                            <v-flex xs6 sm3 md3 lg2>
                              <span class="font-weight-bold">Type</span>
                            </v-flex>
                            <v-flex xs6 sm9 md9 lg10>
                              {{ orderType | allCaps }}
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-flex>
                      <v-flex xs12>
                        <v-divider></v-divider>
                      </v-flex>
                      <v-flex xs12>
                        <v-container fluid grid-list-xs class="pt-3 pb-3 pl-2">
                          <v-layout row wrap>
                            <v-flex xs6 sm3 md3 lg2>
                              <span class="font-weight-bold">Created Date</span>
                            </v-flex>
                            <v-flex xs6 sm9 md9 lg10>
                              {{ createdDateTime | formatDate('DD MMMM YYYY', profile.gmtTimezone) }}
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-flex>
                      <v-flex xs12>
                        <v-divider></v-divider>
                      </v-flex>
                      <v-flex xs12>
                        <v-container fluid grid-list-xs class="pt-3 pb-3 pl-2">
                          <v-layout row wrap>
                            <v-flex xs6 sm3 md3 lg2>
                              <span class="font-weight-bold">Expiry Date</span>
                            </v-flex>
                            <v-flex xs6 sm9 md9 lg10 v-if="expiryDateTime">
                              {{ expiryDateTime | formatDate('DD MMMM YYYY', profile.gmtTimezone) }}
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-flex>
                      <v-flex xs12 v-if="paymentStatus === 'paid' || paymentStatus === 'credit'">
                        <v-divider></v-divider>
                      </v-flex>
                      <v-flex xs12 v-if="paymentStatus === 'paid' || paymentStatus === 'credit'">
                        <v-container fluid grid-list-xs class="pt-3 pb-3 pl-2">
                          <v-layout row wrap>
                            <v-flex xs6 sm3 md3 lg2>
                              <span class="font-weight-bold">Payment Date</span>
                            </v-flex>
                            <v-flex xs6 sm9 md9 lg10>
                              {{ paidDateTime | formatDate('DD MMMM YYYY', profile.gmtTimezone) }}
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-flex>
                      <v-flex xs12>
                        <v-divider></v-divider>
                      </v-flex>
                      <v-flex xs12>
                        <v-container fluid grid-list-xs class="pt-0 pb-0 pl-2">
                          <v-layout row wrap>
                            <v-flex xs6 sm3 md3 lg2 style="padding-top:12px;padding-left:0;">
                              <span class="font-weight-bold">Payment Status</span>
                            </v-flex>
                            <v-flex xs6 sm9 md9 lg10>
                              <v-chip :color="paymentStatusColor" text-color="white" style="width:130px;">
                                <v-avatar>
                                  <v-icon small class="notranslate">{{ paymentStatusIcon }}</v-icon>
                                </v-avatar>
                                <strong>{{ paymentStatus | allCaps }}</strong>
                              </v-chip>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-flex>
                      <v-flex xs12>
                        <v-divider></v-divider>
                      </v-flex>
                      <v-flex xs12>
                        <v-container fluid grid-list-xs class="pt-0 pb-0 pl-2">
                          <v-layout row wrap>
                            <v-flex xs6 sm3 md3 lg2 style="padding-top:12px;padding-left:0;">
                              <span class="font-weight-bold">Delivery Status</span>
                            </v-flex>
                            <v-flex xs6 sm9 md9 lg10>
                              <v-chip :color="deliveryStatusColor" text-color="white" style="width:130px;">
                                <v-avatar>
                                  <v-icon small class="notranslate">{{ deliveryStatusIcon }}</v-icon>
                                </v-avatar>
                                <strong>{{ deliveryStatus | allCaps }}</strong>
                              </v-chip>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-flex>
                      <v-flex xs12>
                        <v-divider class="mb-3"></v-divider>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-flex>
                <v-flex xs12 v-else>
                  <v-container fluid grid-list-xs v-if="userId">
                    <v-layout row wrap>
                      <v-flex xs12 class="mb-4 text-xs-center">
                        <h3>{{ loginEmail }}</h3>
                        <v-btn
                          outline
                          small
                          @click="userId = ''"
                        >
                          Change
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-container>
                  <v-container fluid grid-list-xs v-else>
                    <v-form ref="form" v-model="frmLoadCustomerValid" v-on:submit.prevent>
                      <v-layout row wrap>
                        <v-flex xs8 offset-sm3 sm5 class="mb-4">
                          <v-text-field
                            v-model="loginEmail"
                            :rules="[v => !!v || 'Customer email is required']"
                            label="Customer Email"
                            required
                            v-on:keydown.enter.prevent="getUser(loginEmail)"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs4 sm1>
                          <v-btn
                            outline
                            small
                            :disabled="!frmLoadCustomerValid"
                            @click="getUser(loginEmail)"
                          >
                            Load
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-form>
                  </v-container>
                </v-flex>
                <v-form ref="frmOrder" v-model="frmOrderValid" v-if="userId">
                  <v-container fluid grid-list-xs class="pa-0">
                    <v-layout row wrap>
                      <v-flex xs12 sm6 class="mb-4">
                        <v-container fluid grid-list-xs>
                          <v-layout row wrap>
                            <v-flex xs12>
                              <h3 class="title font-weight-bold">
                                Bill to:
                                <v-btn
                                  outline
                                  small
                                  @click="showAddressDialog('billing')"
                                >
                                  Select address
                                </v-btn>
                              </h3>
                            </v-flex>
                            <v-flex xs12>
                              <v-select
                                v-model="billingTitle"
                                :items="titles"
                                label="Title *"
                                :rules="[v => !!v || 'Title is required']"
                                required
                              ></v-select>
                            </v-flex>
                            <v-flex xs12>
                              <v-text-field
                                v-model="billingFirstName"
                                label="First Name *"
                                :rules="[v => !!v || 'First name is required']"
                                required
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                              <v-text-field
                                v-model="billingLastName"
                                label="Last Name *"
                                :rules="[v => !!v || 'Last name is required']"
                                required
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                              <v-text-field
                                v-model="billingCompany"
                                label="Company Name"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                              <v-textarea
                                label="Address *"
                                v-model="billingAddress"
                                :rules="[v => !!v || 'Address is required']"
                                required
                              ></v-textarea>
                            </v-flex>
                            <v-flex xs12>
                              <v-autocomplete
                                v-model="billingCountryId"
                                :items="countries"
                                item-text="countryName"
                                item-value="countryId"
                                label="Country *"
                                :rules="[v => !!v || 'Country is required']"
                                required
                                @change="clickCountry('billing', billingCountryId)"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex xs12 v-if="billingProvinces && billingProvinces.length > 0">
                              <v-autocomplete
                                v-model="billingProvinceId"
                                :items="billingProvinces"
                                item-text="provinceName"
                                item-value="provinceId"
                                label="Province *"
                                :rules="[v => !!v || 'Province is required']"
                                required
                                @change="clickProvince('billing', billingProvinceId)"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex xs12 v-else>
                              <v-text-field
                                v-model="billingProvinceName"
                                label="Province Name *"
                                :rules="[v => !!v || 'Province Name is required']"
                                required
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 v-if="billingCities && billingCities.length > 0">
                              <v-autocomplete
                                v-model="billingCityId"
                                :items="billingCities"
                                item-text="cityName"
                                item-value="cityId"
                                label="City *"
                                :rules="[v => !!v || 'City is required']"
                                required
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex xs12 v-else>
                              <v-text-field
                                v-model="billingCityName"
                                label="City Name *"
                                :rules="[v => !!v || 'City Name is required']"
                                required
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                              <v-text-field
                                v-model="billingPostCode"
                                label="Post Code *"
                                :rules="[v => !!v || 'Post Code is required']"
                                required
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                              <v-text-field
                                v-model="billingTaxId"
                                :label="'Tax ID' + (billingTaxIdLocalName.length > 0 ? ' (' + billingTaxIdLocalName + ')' : '') + (isBillingTaxIdRequired ? ' *' : '')"
                                :rules="billingTaxIdRules"
                                :required="isBillingTaxIdRequired"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                              <v-text-field
                                v-model="billingPhone"
                                label="Phone *"
                                :rules="[v => !!v || 'Phone is required']"
                                required
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                              <v-text-field
                                v-model="billingEmail"
                                label="Email *"
                                disabled
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-flex>
                      <v-flex xs12 sm6 class="mb-4">
                        <v-container fluid grid-list-xs>
                          <v-layout row wrap>
                            <v-flex xs12>
                              <h3 class="title font-weight-bold">
                                Ship to:
                                <v-btn
                                  outline
                                  small
                                  @click="showAddressDialog('shipping')"
                                >
                                  Select address
                                </v-btn>
                              </h3>
                            </v-flex>
                            <v-flex xs12>
                              <v-select
                                v-model="shippingTitle"
                                :items="titles"
                                label="Title *"
                                :rules="[v => !!v || 'Title is required']"
                                required
                              ></v-select>
                            </v-flex>
                            <v-flex xs12>
                              <v-text-field
                                v-model="shippingFirstName"
                                label="First Name *"
                                :rules="[v => !!v || 'First name is required']"
                                required
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                              <v-text-field
                                v-model="shippingLastName"
                                label="Last Name *"
                                :rules="[v => !!v || 'Last name is required']"
                                required
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                              <v-text-field
                                v-model="shippingCompany"
                                label="Company Name"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                              <v-textarea
                                label="Address *"
                                v-model="shippingAddress"
                                :rules="[v => !!v || 'Address is required']"
                                required
                              ></v-textarea>
                            </v-flex>
                            <v-flex xs12>
                              <v-autocomplete
                                v-model="shippingCountryId"
                                :items="countries"
                                item-text="countryName"
                                item-value="countryId"
                                label="Country *"
                                :rules="[v => !!v || 'Country is required']"
                                required
                                @change="clickCountry('shipping', shippingCountryId)"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex xs12 v-if="shippingProvinces && shippingProvinces.length > 0">
                              <v-autocomplete
                                v-model="shippingProvinceId"
                                :items="shippingProvinces"
                                item-text="provinceName"
                                item-value="provinceId"
                                label="Province *"
                                :rules="[v => !!v || 'Province is required']"
                                required
                                @change="clickProvince('shipping', shippingProvinceId)"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex xs12 v-else>
                              <v-text-field
                                v-model="shippingProvinceName"
                                label="Province Name *"
                                :rules="[v => !!v || 'Province Name is required']"
                                required
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 v-if="shippingCities && shippingCities.length > 0">
                              <v-autocomplete
                                v-model="shippingCityId"
                                :items="shippingCities"
                                item-text="cityName"
                                item-value="cityId"
                                label="City *"
                                :rules="[v => !!v || 'City is required']"
                                required
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex xs12 v-else>
                              <v-text-field
                                v-model="shippingCityName"
                                label="City Name *"
                                :rules="[v => !!v || 'City Name is required']"
                                required
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                              <v-text-field
                                v-model="shippingPostCode"
                                label="Post Code *"
                                :rules="[v => !!v || 'Post Code is required']"
                                required
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                              <v-text-field
                                v-model="shippingTaxId"
                                :label="'Tax ID' + (shippingTaxIdLocalName.length > 0 ? ' (' + shippingTaxIdLocalName + ')' : '') + (isShippingTaxIdRequired ? ' *' : '')"
                                :rules="shippingTaxIdRules"
                                :required="isShippingTaxIdRequired"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                              <v-text-field
                                v-model="shippingPhone"
                                label="Phone *"
                                :rules="[v => !!v || 'Phone is required']"
                                required
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                              <v-text-field
                                v-model="shippingEmail"
                                :rules="[v => !!v || 'E-mail is required', v => /.+@.+/.test(v) || 'E-mail format is invalid']"
                                label="Email *"
                                required
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 v-if="shippingIsPinpointRequired">
                              <div v-if="shippingLatitude !== 0 && shippingLongitude !== 0">
                                <div style="max-width: 200px;">
                                  <v-img :src="getStaticMapUrl(shippingLatitude, shippingLongitude, 200, 200, 16)" aspect-ratio="1" style="border: 1px solid #ababab;"></v-img>
                                </div>
                                <div>
                                  <v-btn
                                    small
                                    @click="showMapDialog('shipping')"
                                  >
                                    Edit Pinpoint
                                  </v-btn>
                                </div>
                              </div>
                              <div v-else style="max-width: 150px;">
                                <div class="text-xs-center">
                                  <v-icon large class="notranslate" color="primary">location_on</v-icon>
                                </div>
                                <div class="text-xs-center subheading">
                                  No Pinpoint Yet
                                </div>
                                <div class="text-xs-center">
                                  <v-btn
                                    small
                                    @click="showMapDialog('shipping')"
                                  >
                                    Set Pinpoint
                                  </v-btn>
                                </div>
                              </div>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-flex>
                      <v-flex xs12>
                        <v-divider class="mt-3"></v-divider>
                      </v-flex>
                      <v-flex xs12 sm3 class="mt-4">
                        <v-container fluid grid-list-xs>
                          <v-layout row wrap>
                            <v-flex xs12>
                              <v-select
                                v-model="currencyCode"
                                :rules="[v => !!v || 'Please choose currency']"
                                v-bind:items="currencies"
                                item-text="currencyCode"
                                item-value="currencyCode"
                                label="Currency"
                                @change="changeCurrency($event)"
                                required
                              ></v-select>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-flex>
                      <v-flex xs12 sm3 class="mt-4">
                        <v-container fluid grid-list-xs>
                          <v-layout row wrap>
                            <v-flex xs12>
                              <v-text-field
                                v-model="exchangeRateToBase"
                                label="Exchange Rate to USD"
                                :rules="[v => !!v || 'Exchange Rate is required']"
                                type="number"
                                required
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-flex>
                      <v-flex xs12 sm3 class="mt-4">
                        <v-container fluid grid-list-xs>
                          <v-layout row wrap>
                            <v-flex xs12>
                              <v-select
                                :items="paymentMethods"
                                item-text="paymentMethodName"
                                item-value="paymentMethodId"
                                label="Payment Method"
                                v-model="cboPaymentMethodId"
                                :rules="[v => !!v || 'Payment method is required']"
                                required
                              ></v-select>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-flex>
                      <v-flex xs12 sm3 class="mt-4">
                        <v-container fluid grid-list-xs>
                          <v-layout row wrap>
                            <v-flex xs12>
                              <v-select
                                :items="taxDeclarePercentages"
                                item-text="caption"
                                item-value="value"
                                label="Declared value"
                                v-model="cboDeclareValuePercentage"
                              ></v-select>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-flex>
                      <v-flex
                        xs12
                        text-xs-center
                        layout
                        align-center
                        justify-center
                        class="mt-5"
                      >
                        <table
                          border=0
                          cellspacing=0
                          class="pt-0"
                          width="100%"
                        >
                          <tr class="grey darken-4">
                            <th class="text-xs-left subheading font-weight-bold white--text hidden-xs-only">
                              SELLER
                            </th>
                            <th class="text-xs-left subheading font-weight-bold white--text" colspan="2">
                              ITEM
                            </th>
                            <th class="text-xs-center subheading font-weight-bold white--text hidden-xs-only">
                              QTY
                            </th>
                            <th class="text-xs-center subheading font-weight-bold white--text hidden-xs-only">
                              UNIT PRICE
                            </th>
                            <th class="text-xs-center subheading font-weight-bold white--text">
                              TOTAL PRICE
                            </th>
                          </tr>

                          <tr v-for="(item, index) in orderItems" :key="index">
                            <td valign="top" class="pa-1 pt-3 pb-3 hidden-xs-only">
                              {{ item.storeName | allCaps }}
                              <br>
                              <v-btn
                                icon
                                class="hidden-xs-only"
                                @click="deleteItemIndex=index; deleteItemDialog = !deleteItemDialog"
                              >
                                <v-icon>delete</v-icon>
                              </v-btn>
                            </td>
                            <td valign="top" class="pa-1 pt-3 pb-3" style="max-width: 100px;">
                              <img v-if="item.image" :src="item.image" class="item-thumb">
                              <div v-else style="width:100%; height: 70px; border: 1px solid #ababab; padding: 15px 10px;">No Image</div>
                              <div class="caption item-identity"><a :href="def.marketplaceDomain + item.url" class="white--text" target="_blank">{{ item.sku }}</a></div>
                              <div class="caption">Unit weight: {{ formatPrice(item.unitWeight) }}kg</div>
                              <div class="caption mt-2" v-if="item.shippingSubsidyAmount && item.shippingSubsidyAmount > 0">
                                <span class="font-weight-bold green--text">{{ currencySign }}{{ formatPrice(item.shippingSubsidyAmount, currencyDecimals, currencyDecimalSign) }} Free Shipping</span>
                                with {{ item.shippingSubsidyCourierName }} {{ item.shippingSubsidyServiceName }}
                              </div>
                              <div v-else-if="item.shippingSubsidies && item.shippingSubsidies.freeShipping && item.shippingSubsidies.freeShipping.isFreeShipping === '1'" class="caption mt-2">
                                <span class="font-weight-bold green--text">Free Shipping Available</span>
                              </div>
                              <v-btn
                                icon
                                class="hidden-sm-and-up"
                                @click="deleteItemIndex=index; deleteItemDialog = !deleteItemDialog"
                              >
                                <v-icon>delete</v-icon>
                              </v-btn>
                            </td>
                            <td valign="top" class="pa-2 pt-3 pb-3 text-xs-left body-1 font-weight-regular" width="50%">
                              <div>
                                <v-textarea
                                  label=""
                                  height="20"
                                  auto-grow
                                  v-model="item.name"
                                  class="mt-5"
                                  :rules="[v => !!v || 'Name is required']"
                                  required
                                ></v-textarea>
                              </div>
                              <div class="caption">
                                <div v-for="param in item.itemParams" :key="param.name">
                                  <span v-if="param.value">
                                    <v-text-field
                                      v-model="param.value"
                                      :rules="[v => !!v || 'Value is required']"
                                      :label="param.name"
                                      required
                                    ></v-text-field>
                                  </span>
                                  <span v-if="param.selections" class="font-weight-medium">{{ param.name }}: </span>
                                  <div v-if="param.selections">
                                    <div v-for="selection in param.selections" :key="selection.name">
                                      {{ selection.name }}
                                      <span v-if="selection.price > 0 || selection.priceInBase > 0">{{ currencySign }}{{ formatPrice(selection.priceInBase / exchangeRateToBase, currencyDecimals, currencyDecimalSign) }}</span>
                                      <span v-if="selection.weight > 0"> ({{ selection.weight }}kg)</span>
                                    </div>
                                  </div>
                                </div>
                                <div v-for="option in item.options" :key="option.optionName">
                                  <span class="font-weight-medium">{{ option.optionName }}:</span> <span>{{ option.valueName }}</span>
                                </div>
                              </div>
                              <div class="hidden-sm-and-up">By {{ item.storeName | allCaps }}</div>
                              <div class="pt-3 subheading font-weight-bold hidden-sm-and-up">
                                <v-container fluid grid-list-lg class="pa-0">
                                  <v-layout row wrap>
                                    <v-flex xs4>
                                      <v-text-field
                                        v-model="item.qty"
                                        :rules="[v => v > 0 || 'Qty is required']"
                                        label="Qty"
                                        type="number"
                                        required
                                      ></v-text-field>
                                    </v-flex>
                                    <v-flex xs8>
                                      <v-text-field
                                        v-model="item.unitPrice"
                                        :rules="[v => v > 0 || 'Unit price is required']"
                                        :prefix="currencySign"
                                        label="Unit Price"
                                        type="number"
                                        required
                                      ></v-text-field>
                                    </v-flex>
                                  </v-layout>
                                </v-container>
                              </div>
                            </td>
                            <td valign="top" colspan="3" class="pa-2 body-2 text-xs-center subheading font-weight-bold hidden-xs-only" style="width:290px;">
                              <v-container fluid grid-list-lg class="pa-0">
                                <v-layout row wrap>
                                  <v-flex xs3>
                                    <v-text-field
                                      v-model="item.qty"
                                      :rules="[v => v > 0 || 'Qty is required']"
                                      type="number"
                                      required
                                    ></v-text-field>
                                  </v-flex>
                                  <v-flex xs5>
                                    <v-text-field
                                      v-model="item.unitPrice"
                                      :rules="[v => v > 0 || 'Unit price is required']"
                                      :prefix="currencySign"
                                      type="number"
                                      required
                                    ></v-text-field>
                                  </v-flex>
                                  <v-flex xs4>
                                    {{ currencySign }}{{ formatPrice(item.qty * item.unitPrice, currencyDecimals, currencyDecimalSign) }}
                                  </v-flex>
                                  <v-flex xs12 class="pa-3">
                                    <v-data-table
                                      :headers="bulkPricingHeaders"
                                      :items="item.currentRetailQtyPricingInBase"
                                      hide-actions
                                      item-key="name"
                                      class="bulk-pricing-table elevation-2 pa-3"
                                    >
                                      <template slot="items" slot-scope="props">
                                        <tr>
                                          <td class="text-xs-center">{{ props.item.qty }}</td>
                                          <td class="text-xs-center">{{ currencySign }}{{ formatPrice(props.item.price / exchangeRateToBase, currencyDecimals, currencyDecimalSign) }}</td>
                                        </tr>
                                      </template>
                                    </v-data-table>
                                  </v-flex>
                                </v-layout>
                              </v-container>
                            </td>
                          </tr>

                          <tr>
                            <td colspan=6 class="text-xs-left">
                              <v-btn outline @click="searchProductDialog = !searchProductDialog">
                                <v-icon class="mr-2">add</v-icon>
                                Add Item
                              </v-btn>
                            </td>
                          </tr>
                          <tr>
                            <td colspan=2 class="text-xs-left subheading font-weight-medium">
                              Sub Total
                            </td>
                            <td colspan=4 class="text-xs-right subheading font-weight-bold">
                              {{ currencySign }}{{ formatPrice(this.subTotal, currencyDecimals, currencyDecimalSign) }}
                            </td>
                          </tr>
                          <tr>
                            <td colspan=4 class="text-xs-left subheading font-weight-medium">
                              Shipping Cost
                              <v-btn outline small v-if="orderItems.length > 0 && routing.length > 0" @click="refreshRouting">
                                Recalculate
                              </v-btn>
                              <v-btn outline small v-if="orderItems.length > 0 && routing.length === 0" @click="refreshRouting">
                                Calculate
                              </v-btn>
                              <table border=0 width="100%">
                                <tr v-for="(route, routeIndex) in routing" :key="routeIndex">
                                  <td width="80%" class="no-border">
                                    <v-select
                                      :items="route.shippingRates"
                                      item-text="name"
                                      item-value="courierIdServiceCode"
                                      :label="'Shipping from ' + route.storeName + ' - ' + route.storeCityName + ' (' + formatPrice(route.shippingWeight) + 'kg)'"
                                      v-model="route.courierIdServiceCode"
                                      @change="selectCourier(routeIndex, route.courierIdServiceCode)"
                                      :rules="[v => !!v || 'Courier is required']"
                                      required
                                    ></v-select>
                                  </td>
                                  <td width="20%" class="no-border">
                                    <v-btn outline small block v-if="routing[routeIndex].courierIdServiceCode" @click="showOverrideShippingCostDialog(routeIndex)">
                                      Override
                                    </v-btn>
                                  </td>
                                </tr>
                              </table>
                            </td>
                            <td colspan=2 class="text-xs-right subheading font-weight-bold">
                              {{ currencySign }}{{ formatPrice(this.deliveryCost, currencyDecimals, currencyDecimalSign) }}
                            </td>
                          </tr>
                          <tr>
                            <td
                              colspan="4"
                              class="text-xs-left subheading font-weight-medium"
                            >
                              Import Duties
                              <table border="0" width="100%">
                                <tr
                                  v-for="(route, routeIndex) in routing"
                                  :key="routeIndex"
                                >
                                  <td width="60%" class="no-border">
                                    From {{ route.storeName }} -
                                    {{ route.storeCountryName }}
                                  </td>
                                  <td width="20%" class="no-border text-xs-right">
                                    {{
                                      currencySign +
                                      formatPrice(
                                        route.importTariff,
                                        currencyDecimals,
                                        currencyDecimalSign
                                      )
                                    }}
                                  </td>
                                  <td width="20%" class="no-border">
                                    <v-btn
                                      outline
                                      small
                                      block
                                      v-if="
                                        routing[routeIndex].courierIdServiceCode
                                      "
                                      @click="
                                        showOverrideImportTariffDialog(
                                          routeIndex
                                        )
                                      "
                                    >
                                      Override
                                    </v-btn>
                                  </td>
                                </tr>
                              </table>
                            </td>
                            <td
                              colspan="2"
                              class="text-xs-right subheading font-weight-bold"
                            >
                              {{ currencySign +
                                formatPrice(
                                  totalImportTariff,
                                  currencyDecimals,
                                  currencyDecimalSign
                                )
                              }}
                            </td>
                          </tr>
                          <tr>
                            <td colspan=2 class="text-xs-left subheading font-weight-medium">
                              Grand Total
                            </td>
                            <td colspan=4 class="text-xs-right subheading font-weight-bold">
                              {{ currencySign }}{{ formatPrice(this.subTotal + this.deliveryCost + this.totalImportTariff, currencyDecimals, currencyDecimalSign) }}
                            </td>
                          </tr>
                        </table>
                      </v-flex>
                    </v-layout>
                  </v-container>
                  <v-btn
                    block
                    large
                    color="primary"
                    class="mt-4"
                    :disabled="!frmOrderValid"
                    @click="submit"
                  >Save Order</v-btn>

                </v-form>
              </v-layout>
            </v-container>

          </v-card>
        </v-flex>
      </v-layout>
    </v-content>

    <v-dialog
      v-model="listAddressDialog"
      max-width="800"
    >
      <v-card class="pa-4">
        <h3 class="headline font-weight-bold mb-3">Customer address</h3>
        <div style="height:300px;overflow-y:auto;border:1px solid #999999;">
          <v-container fluid grid-list-xs v-if="addresses.length > 0" >
            <v-layout row wrap v-for="(address, addressIndex) in addresses" :key="address.userAddressId">
              <v-flex xs8>
                <strong>{{ address.title }} {{ address.firstName }} {{ address.lastName }}</strong>
                <span v-if="address.company"><br>Company: {{ address.company }}</span>
                <br>{{ address.address }}
                <br>{{ address.cityName }}, {{ address.postCode }}, {{ address.provinceName }}, {{ address.countryName }}
                <br>{{ address.phone }}
                <span v-if="address.taxId"><br>Tax ID: {{ address.taxId }}</span>
              </v-flex>
              <v-flex xs4 class="text-xs-right">
                <v-btn
                  outline
                  @click="useAddress(addressIndex, addressDialogTarget); listAddressDialog=false;"
                >
                  Use
                </v-btn>
              </v-flex>
              <v-flex xs12 v-if="addressIndex < (addresses.length - 1)">
                <v-divider class="mt-4 mb-4"></v-divider>
              </v-flex>
            </v-layout>
          </v-container>
          <v-container fluid grid-list-xs v-else>
            <v-layout row wrap>
              <v-flex
                xs12
                justify-center
                align-center
                text-xs-center
              >
                <v-icon x-large color="primary">error_outline</v-icon>
                <div>
                  No address yet
                </div>
              </v-flex>
              <v-flex xs12>
                <v-divider class="mt-4 mb-4"></v-divider>
              </v-flex>
            </v-layout>
          </v-container>
        </div>
        <v-btn
          outline
          class="mt-3"
          @click="showNewAddressDialog"
        >
          <v-icon left class="notranslate">add</v-icon>
          New address
        </v-btn>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="newAddressDialog"
      max-width="800"
    >
      <v-card class="pa-4">
        <h3 class="headline font-weight-bold">New address</h3>
        <v-form ref="frmNewAddress" v-model="frmNewAddressValid" @submit.prevent="">
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs12 sm2>
                <v-select
                  :items="titles"
                  label="Title"
                  v-model="cboTitle"
                  :rules="[v => !!v || 'Title is required']"
                  required
                ></v-select>
              </v-flex>
              <v-flex xs12 sm5>
                <v-text-field
                  label="First Name"
                  v-model="txtFirstName"
                  :rules="[v => !!v || 'First name is required']"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm5>
                <v-text-field
                  label="Last Name"
                  v-model="txtLastName"
                  :rules="[v => !!v || 'Last name is required']"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm3>
                <v-autocomplete
                  :items="countries"
                  item-text="countryName"
                  item-value="countryId"
                  label="Country"
                  v-model="cboCountryId"
                  :rules="[v => !!v || 'Country is required']"
                  required
                  @change="clickCountry('address', cboCountryId)"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 sm3 v-if="provinces.length > 0">
                <v-autocomplete
                  v-model="cboProvinceId"
                  :items="provinces"
                  item-text="provinceName"
                  item-value="provinceId"
                  label="Province"
                  :rules="[v => !!v || 'Province is required']"
                  required
                  @change="clickProvince('address', cboProvinceId)"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 sm3 v-else>
                <v-text-field
                  label="Province"
                  v-model="txtProvinceName"
                  :rules="[v => !!v || 'Province is required']"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm3 v-if="cities.length > 0">
                <v-autocomplete
                  v-model="cboCityId"
                  :items="cities"
                  item-text="cityName"
                  item-value="cityId"
                  label="City"
                  :rules="[v => !!v || 'City is required']"
                  required
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 sm3 v-else>
                <v-text-field
                  label="City"
                  v-model="txtCityName"
                  :rules="[v => !!v || 'City is required']"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm3>
                <v-text-field
                  label="Post Code"
                  v-model="txtPostCode"
                  :rules="[v => !!v || 'Post code is required']"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm8>
                <v-text-field
                  label="Company Name"
                  v-model="txtCompany"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm4>
                <v-text-field
                  :label="'Tax ID' + (taxIdLocalName.length > 0 ? ' (' + taxIdLocalName + ')' : '')"
                  v-model="txtTaxId"
                  :rules="taxIdRules"
                  :required="isTaxIdRequired"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm9>
                <v-textarea
                  label="Address"
                  v-model="txtAddress"
                  :rules="[v => !!v || 'Address is required']"
                  required
                ></v-textarea>
              </v-flex>
              <v-flex xs12 sm3 class="text-xs-center" v-if="isPinpointRequired">
                <div v-if="latitude !== 0 && longitude !== 0">
                  <div>
                    <v-img :src="getStaticMapUrl(latitude, longitude, 200, 200, 16)" aspect-ratio="1" style="border: 1px solid #ababab;"></v-img>
                  </div>
                  <div>
                    <v-btn
                      small
                      @click="showMapDialog('address')"
                    >
                      Edit Pinpoint
                    </v-btn>
                  </div>
                </div>
                <div v-else>
                  <div class="text-xs-center">
                    <v-icon large class="notranslate" color="primary">location_on</v-icon>
                  </div>
                  <div class="text-xs-center subheading">
                    No Pinpoint Yet
                  </div>
                  <div>
                    <v-btn
                      small
                      @click="showMapDialog('address')"
                    >
                      Set Pinpoint
                    </v-btn>
                  </div>
                </div>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field
                  label="Phone No"
                  v-model="txtPhone"
                  :rules="[v => !!v || 'Phone is required']"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field
                  label="Email"
                  v-model="txtEmail"
                  :rules="[v => !!v || 'E-mail is required', v => /.+@.+/.test(v) || 'E-mail format is invalid']"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12>
                <v-btn
                  block
                  :disabled="!frmNewAddressValid"
                  @click="addAddress"
                >
                  Save
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="mapDialog"
      max-width="600"
    >
      <v-card class="pa-4">
        <h3 class="headline font-weight-bold">Set Pinpoint</h3>
        <div class="caption mb-3">Please drag the marker to your address location</div>
        <input id="pac-input" class="controls" type="text" placeholder="Search here" onfocus="autocomplete">
        <div id="map" class="mt-3"></div>
        <v-btn
          block
          large
          color="primary"
          class="mt-3"
          @click="savePinpoint"
        >
          Save Pinpoint
        </v-btn>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="searchProductDialog"
      max-width="1000"
    >
      <v-card class="pa-4">
        <h3 class="headline font-weight-bold">Add Item</h3>
        <v-container fluid grid-list-lg class="pa-0">
          <v-layout row wrap>
            <v-flex xs4 sm3>
              <v-text-field
                label="Search for"
                v-model="txtProductName"
                @keyup.enter="getProducts(cboProductCategory, txtProductName, cboSeller)"
              ></v-text-field>
            </v-flex>
            <v-flex xs8 sm5>
              <v-select
                :items="categories"
                item-text="name"
                item-value="categoryId"
                label="Category"
                v-model="cboProductCategory"
              ></v-select>
            </v-flex>
            <v-flex xs10 sm3>
              <v-select
                :items="sellers"
                item-text="storeName"
                item-value="userId"
                label="Seller"
                v-model="cboSeller"
              ></v-select>
            </v-flex>
            <v-flex xs2 sm1>
              <v-btn
                icon
                @click="getProducts(cboProductCategory, txtProductName, cboSeller)"
              >
                <v-icon>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
        <div style="height:400px;overflow-y:auto;border:1px solid #999999;" ref="productListDiv">
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs6 sm4 md3 v-for="(item, index) in productListItems" :key="index">
                <v-card flat class="pa-2">
                  <v-img v-if="item.images.length > 0" :src="item.images[0].smallUrl" aspect-ratio="1.2" class="mb-2"></v-img>
                  <div v-else style="width:100%; height: 150px; border: 1px solid #333333; padding: 20px 10px; text-align: center;">No Image</div>
                  <div v-if="item.shippingSubsidies && item.shippingSubsidies.freeShipping && item.shippingSubsidies.freeShipping.isFreeShipping === '1'" style="position:absolute;top:15px;left:15px;"><img src="/static/img/free-shipping.png" style="width:55px;height:auto;" /></div>
                </v-card>
                <v-tooltip bottom offset-overflow :max-width=250>
                  <div slot="activator">{{ item.name | truncate(50) }}</div>
                  <span>{{ item.name }}</span>
                </v-tooltip>
                <div class="body-2 font-weight-bold mt-3">{{ currencySign + formatPrice(item.retailPriceInBase / exchangeRateToBase, currencyDecimals, currencyDecimalSign) }}</div>
                <div class="caption font-weight-light">As low as <strong>{{ currencySign + formatPrice(item.lowestPriceInBase / exchangeRateToBase, currencyDecimals, currencyDecimalSign) }}</strong></div>
                <v-btn
                  outline
                  block
                  small
                  class="mt-3"
                  @click="clickAddItem(index)"
                >
                  Add
                </v-btn>
                <div class="caption font-weight-light">By {{ item.storeName }}</div>
              </v-flex>
            </v-layout>
          </v-container>
        </div>
        <v-container fluid grid-list-lg class="pa-2">
          <v-layout row wrap>
            <v-flex sm6 hidden-xs-only>
            </v-flex>
            <v-flex sm3 xs6>
              <v-btn
                block
                outline
                :disabled="productListOffset <= 0"
                @click="getProducts(cboProductCategory, txtProductName, cboSeller, '', (productListOffset-productListLimit <= 0 ? 0 : productListOffset-productListLimit))"
              >
                Prev
              </v-btn>
            </v-flex>
            <v-flex sm3 xs6>
              <v-btn
                block
                outline
                :disabled="productListOffset + productListLimit >= productListTotal"
                @click="getProducts(cboProductCategory, txtProductName, cboSeller, '', productListOffset+productListLimit)"
              >
                Next
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="addItemDialog"
      max-width="350"
    >
      <v-card class="pa-4">
        <h3 class="headline font-weight-bold">Add Item</h3>
        <v-form ref="frmAddItem" v-model="frmAddItemValid">
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs12>
                <v-select
                  :items="addItemSkus"
                  item-text="sku"
                  item-value="sku"
                  label="SKU"
                  v-model="cboAddItemSku"
                  :rules="[v => !!v || 'SKU is required']"
                  required
                ></v-select>
              </v-flex>
              <v-flex xs12 v-for="(param, paramIndex) in addItemParams" :key="paramIndex">
                <v-text-field
                  v-if="param.type === 'text'"
                  :label="param.name"
                  v-model="txtAddItemParams[paramIndex].value"
                  :rules="[v => !!v || 'Value is required']"
                  required
                ></v-text-field>
                <div v-if="param.type === 'file'" :title="param.hint">
                  <v-card flat>
                    <v-container fluid class="pa-0 mb-3">
                      <v-layout row wrap>
                        <v-flex xs12>
                          {{ param.name }}:
                        </v-flex>
                        <v-flex xs12>
                          <input
                            type="file"
                            :name="param.productParamId"
                            :ref="param.productParamId"
                            accept="*"
                            @change="onFilePicked"
                            @click="$refs[param.productParamId].value = null"
                          >
                        </v-flex>
                      </v-layout>
                    </v-container>
                    <v-divider color="gray"></v-divider>
                  </v-card>
                </div>
                <v-select
                  v-if="param.type === 'select' && param.isMultipleSelection === '0'"
                  :items="param.selectionItems"
                  item-text="selectionDisplayName"
                  item-value="selectionName"
                  :label="param.name"
                  v-model="txtAddItemParams[paramIndex].selections[0].name"
                  :rules="[v => !!v || 'Value is required']"
                  required
                ></v-select>
                <v-select
                  v-if="param.type === 'select' && param.isMultipleSelection === '1'"
                  :items="param.selectionItems"
                  item-text="selectionDisplayName"
                  item-value="selectionName"
                  :label="param.name"
                  v-model="txtAddItemParams[paramIndex].selections"
                  multiple
                ></v-select>
              </v-flex>
              <v-flex xs12>
                <v-btn
                  block
                  @click="addItemFromDialog"
                >
                  Add Item
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="deleteItemDialog"
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">Confirm to delete this item?</v-card-title>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="primary"
            flat="flat"
            @click="deleteItemDialog=false"
          >
            Cancel
          </v-btn>

          <v-btn
            color="primary"
            flat="flat"
            @click="deleteItem(deleteItemIndex); deleteItemDialog=false;"
          >
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="overrideShippingCostDialog"
      max-width="290"
    >
      <v-card class="pa-4">
        <h3 class="headline font-weight-bold">{{ overrideCourierName }}</h3>
        <div>{{ overrideServiceName }}</div>
        <v-form ref="frmAddItem" v-model="frmOverrideShippingCostValid" @submit.prevent="">
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                  label="Shipping Cost"
                  @focus="$event.target.select()"
                  v-model="txtNewShippingCost"
                  :prefix="currencySign"
                  :rules="[v => !!v || 'Value is required']"
                  @keyup.enter="overrideShippingCost(overrideShippingRouteIndex, txtNewShippingCost)"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-btn
                  block
                  :disabled="!frmOverrideShippingCostValid"
                  @click="overrideShippingCost(overrideShippingRouteIndex, txtNewShippingCost)"
                >
                  Set
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="overrideImportTariffDialog"
      max-width="290"
    >
      <v-card class="pa-4">
        <h3 class="headline font-weight-bold">{{ overrideStoreName }}</h3>
        <div>{{ overrideStoreCountryName }}</div>
        <v-form ref="frmOverrideImportTariff" v-model="frmOverrideImportTariffValid" @submit.prevent="">
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                  label="Import Duties"
                  @focus="$event.target.select()"
                  v-model="txtNewImportTariff"
                  :prefix="currencySign"
                  :rules="[v => !!v || 'Value is required']"
                  @keyup.enter="overrideImportTariff(overrideShippingRouteIndex, txtNewImportTariff)"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-btn
                  block
                  :disabled="!frmOverrideImportTariffValid"
                  @click="overrideImportTariff(overrideShippingRouteIndex, txtNewImportTariff)"
                >
                  Set
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="loading"
      hide-overlay
      persistent
      width="220"
    >
      <loading></loading>
    </v-dialog>
  </div>
</template>

<style scoped>

td, th {
  padding: 15px 15px;
}

td {
  border-top: 1px solid #666666;
}

td.no-border {
  border: none;
}

.item-thumb {
  width: 100%;
  min-width: 60px;
  height: auto;
  border: 1px solid #dedede;
}

#map {
  height: 400px;
  width: 100%;
}

.pac-target-input {
  border: 1px solid #333333;
  width: 100%;
  padding: 5px;
}

</style>

<script>
import SideDrawer from '@/components/SideDrawer.vue'
import axios from 'axios'
import router from '../router'
import Loading from '@/components/Loading.vue'
import $Scriptjs from 'scriptjs'

export default {
  props: [
    'salesOrderNo'
  ],
  components: {
    SideDrawer,
    Loading
  },
  data () {
    return {
      profile: this.$store.getters.getProfile,
      def: this.$store.getters.getDef,
      drawer: false,
      loading: false,
      invoiceNo: '',
      currencies: [],
      currencyCode: this.$store.getters.getDef.currency.currencyCode,
      currencySign: this.$store.getters.getDef.currency.sign,
      currencyDecimals: this.$store.getters.getDef.currency.decimals,
      currencyDecimalSign: this.$store.getters.getDef.currency.decimalSign,
      exchangeRateToBase: this.$store.getters.getDef.currency.exchangeRateToBase,
      orderItems: [],
      addresses: [],
      deleteItemDialog: false,
      deleteItemIndex: 0,
      listAddressDialog: false,
      addressDialogTarget: 'billing',
      newAddressDialog: false,
      frmLoadCustomerValid: false,
      loginEmail: '',
      frmNewAddressValid: false,
      cboTitle: '',
      txtFirstName: '',
      txtLastName: '',
      txtCompany: '',
      txtAddress: '',
      txtPostCode: '',
      isValidateProvince: false,
      isValidateCity: false,
      cboCityId: '',
      txtCityName: '',
      cities: [],
      cboProvinceId: '',
      txtProvinceName: '',
      provinces: [],
      cboCountryId: '',
      countries: [],
      txtPhone: '',
      txtTaxId: '',
      taxIdRules: [],
      taxIdLocalName: '',
      isTaxIdRequired: false,
      txtEmail: '',
      isPinpointRequired: false,
      latitude: 0,
      longitude: 0,
      mapDialog: false,
      mapDialogTarget: '',
      marker: {},
      userId: '',
      frmOrderValid: false,
      createdDateTime: '',
      expiryDateTime: '',
      billingTitle: '',
      billingFirstName: '',
      billingLastName: '',
      billingCompany: '',
      billingAddress: '',
      billingPostCode: '',
      isValidateBillingProvince: false,
      isValidateBillingCity: false,
      billingCityId: '',
      billingCityName: '',
      billingCities: [],
      billingProvinceId: '',
      billingProvinceName: '',
      billingProvinces: [],
      billingCountryId: '',
      billingCountryName: '',
      billingPhone: '',
      billingTaxId: '',
      billingTaxIdRules: null,
      billingTaxIdLocalName: '',
      isBillingTaxIdRequired: false,
      billingEmail: '',
      shippingTitle: '',
      shippingFirstName: '',
      shippingLastName: '',
      shippingCompany: '',
      shippingAddress: '',
      shippingPostCode: '',
      isValidateShippingProvince: false,
      isValidateShippingCity: false,
      shippingCityId: '',
      shippingCityName: '',
      shippingCities: [],
      shippingProvinceId: '',
      shippingProvinceName: '',
      shippingProvinces: [],
      shippingCountryId: '',
      shippingCountryName: '',
      shippingPhone: '',
      shippingTaxId: '',
      shippingTaxIdRules: null,
      shippingTaxIdLocalName: '',
      isShippingTaxIdRequired: false,
      shippingEmail: '',
      shippingIsPinpointRequired: false,
      shippingLatitude: 0,
      shippingLongitude: 0,
      orderType: '',
      orderStatus: '',
      paymentStatus: '',
      paymentStatusIcon: '',
      paymentStatusColor: 'grey darken-2',
      paidDateTime: '',
      deliveryStatus: '',
      deliveryStatusIcon: '',
      deliveryStatusColor: 'grey darken-2',
      paymentMethods: [],
      cboPaymentMethodId: '',
      cboDeclareValuePercentage: null,
      courierName: '',
      serviceName: '',
      deliveryCost: 0,
      totalImportTariff: 0,
      subTotal: 0,
      searchProductDialog: false,
      cboSeller: '',
      sellers: [],
      cboProductCategory: '',
      txtProductName: '',
      categories: [],
      productListItems: [],
      productListLimit: 10,
      productListOffset: 0,
      productListTotal: 0,
      addItemDialog: false,
      addItemProductIndex: null,
      frmAddItemValid: false,
      cboAddItemSku: '',
      txtAddItemParams: [],
      addItemSkus: [],
      addItemParams: [],
      addItemFiles: [],
      overrideShippingCostDialog: false,
      overrideShippingRouteIndex: null,
      frmOverrideShippingCostValid: false,
      overrideCourierName: '',
      overrideServiceName: '',
      txtNewShippingCost: 0,
      overrideImportTariffDialog: false,
      frmOverrideImportTariffValid: false,
      txtNewImportTariff: 0,
      overrideStoreName: '',
      overrideStoreCountryName: '',
      couriers: [],
      routing: [],
      importTariffs: [],
      bulkPricingHeaders: [
        {
          text: 'QTY',
          align: 'center',
          sortable: false,
          value: 'qty'
        },
        {
          text: 'PRICE',
          align: 'center',
          sortable: false,
          value: 'price'
        }
      ]
    }
  },
  computed: {
  },
  mounted () {
    this.openDrawerForDesktop()
    this.getCurrencies()
    this.getCountries()
    this.getPaymentMethods()
    this.getSalesOrderDetails()
    this.getCategories()
    this.getSellers()
    this.getImportTariffs()

    $Scriptjs('https://maps.googleapis.com/maps/api/js?key=' + process.env.VUE_APP_GOOGLE_API_KEY + '&libraries=places&v=weekly', () => {
      // this.initMap()
    })
  },

  watch: {
    cboCourier (newValue, oldValue) {
      for (var c = 0; c < this.couriers.length; ++c) {
        if (this.couriers[c].courierId === newValue) {
          this.courierServices = this.couriers[c].rates
          break
        }
      }
    },
    orderItems: {
      // This will let Vue know to look inside the array
      deep: true,

      // Will fire as soon as the component is created
      immediate: true,

      // We have to move our method to a handler field
      handler: function (val, oldVal) {
        console.log('item change')
        var total = 0
        for (var i in val) {
          total += (parseInt(val[i].qty) * parseFloat(val[i].unitPrice))
        }
        this.subTotal = total
      }
    },
    routing: {
      // This will let Vue know to look inside the array
      deep: true,

      // Will fire as soon as the component is created
      immediate: true,

      // We have to move our method to a handler field
      handler: function (val, oldVal) {
        this.sumDeliveryCost()
        this.sumImportTariff()
      }
    }
  },

  methods: {
    showMapDialog: function (target) {
      this.mapDialogTarget = target
      this.initMap()
      this.mapDialog = true
      this.loading = false
    },
    initMap: function () {
      var _this = this
      if (_this.mapDialogTarget === 'address') {
        if (_this.latitude !== 0 && _this.longitude !== 0) {
          _this.loadMap(_this.latitude, _this.longitude)
        } else {
          // geocode address to get nearby lat lng
          _this.loading = true
          axios.get(process.env.VUE_APP_API_ROOT + '/v1/geo/geocode/' + _this.txtAddress + '/' + (_this.txtCityName || _this.cboCityId) + '/' + (_this.txtProvinceName || _this.cboProvinceId) + '/' + _this.cboCountryId)
            .then(resp => {
              console.log(resp.data)
              if (resp.data.status === 'success') {
                _this.loadMap(resp.data.data.latitude, resp.data.data.longitude)
              } else {
                console.log('unable to load address: ' + resp.data.message)
              }
            })
            .catch(function (error) {
              if (error.response) {
                console.log(error.response.status)
                if (error.response.status === 401) {
                  _this.$store.dispatch('AUTH_LOGOUT')
                  router.push('/login?next=' + _this.$route.fullPath)
                }
              }
            })
        }
      } else if (_this.mapDialogTarget === 'shipping') {
        if (_this.shippingLatitude !== 0 && _this.shippingLongitude !== 0) {
          _this.loadMap(_this.shippingLatitude, _this.shippingLongitude)
        } else {
          // geocode address to get nearby lat lng
          _this.loading = true
          axios.get(process.env.VUE_APP_API_ROOT + '/v1/geo/geocode/' + _this.shippingAddress + '/' + (_this.shippingCityName || _this.shippingCityId) + '/' + (_this.shippingProvinceName || _this.shippingProvinceId) + '/' + _this.shippingCountryId)
            .then(resp => {
              console.log(resp.data)
              if (resp.data.status === 'success') {
                _this.loadMap(resp.data.data.latitude, resp.data.data.longitude)
              } else {
                console.log('unable to load address: ' + resp.data.message)
              }
            })
            .catch(function (error) {
              if (error.response) {
                console.log(error.response.status)
                if (error.response.status === 401) {
                  _this.$store.dispatch('AUTH_LOGOUT')
                  router.push('/login?next=' + _this.$route.fullPath)
                }
              }
            })
        }
      }
    },
    loadMap: function (lat, lng) {
      let _this = this
      let google = window.google
      const center = { lat: lat, lng: lng }
      const map = new google.maps.Map(document.getElementById('map'), {
        center: center,
        zoom: 18
      })

      // marker
      _this.marker = new google.maps.Marker({
        position: center,
        map,
        draggable: true,
        title: 'Address'
      })
      console.log('lat: ' + _this.marker.getPosition().lat())
      console.log('lng: ' + _this.marker.getPosition().lng())

      const geocoder = new google.maps.Geocoder()
      google.maps.event.addListener(_this.marker, 'dragend', function (event) {
        let lat = _this.marker.getPosition().lat()
        let lng = _this.marker.getPosition().lng()
        console.log('lat: ' + _this.marker.getPosition().lat())
        console.log('lng: ' + _this.marker.getPosition().lng())
        _this.geocodeLatLng(geocoder, map, lat, lng)
      })

      // autocomplete
      // Create a bounding box with sides ~10km away from the center point
      const input = document.getElementById('pac-input')
      const defaultBounds = {
        north: center.lat + 0.1,
        south: center.lat - 0.1,
        east: center.lng + 0.1,
        west: center.lng - 0.1
      }
      const options = {
        bounds: defaultBounds,
        componentRestrictions: { country: _this.cboCountryId },
        fields: ['address_components', 'geometry', 'icon', 'name'],
        origin: center,
        strictBounds: false,
        types: ['establishment']
      }
      const autoComplete = new google.maps.places.Autocomplete(input, options)
      google.maps.event.addListener(autoComplete, 'place_changed', () => { // arrow function
        let place = autoComplete.getPlace()
        console.log(place)
        const position = {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng()
        }
        _this.marker.setPosition(position)
        map.panTo(position)
        console.log('lat: ' + _this.marker.getPosition().lat())
        console.log('lng: ' + _this.marker.getPosition().lng())
      })
    },
    geocodeLatLng: function (geocoder, map, lat, lng) {
      const latlng = {
        lat: parseFloat(lat),
        lng: parseFloat(lng)
      }
      geocoder.geocode({ location: latlng }, (results, status) => {
        if (status === 'OK') {
          if (results[0]) {
            console.log('geocode success')
            console.log(results[0])
          } else {
            window.alert('No results found')
          }
        } else {
          window.alert('Geocoder failed due to: ' + status)
        }
      })
    },
    savePinpoint: function () {
      if (this.mapDialogTarget === 'address') {
        this.latitude = this.marker.getPosition().lat()
        this.longitude = this.marker.getPosition().lng()
      } else if (this.mapDialogTarget === 'shipping') {
        this.shippingLatitude = this.marker.getPosition().lat()
        this.shippingLongitude = this.marker.getPosition().lng()
      }
      this.mapDialog = false
    },
    getImportTariffs: function () {
      this.loading = true
      axios.get(process.env.VUE_APP_API_ROOT + '/v1/import/tariffs')
        .then(resp => {
          console.log(resp.data)
          this.loading = false
          if (resp.data.status === 'success') {
            this.importTariffs = resp.data.data
          } else {
            console.log('unable to load import tariffs: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + this.$route.fullPath)
            } else if (error.response.status === 403) {
              this.showAlert(error)
            }
            this.loading = false
          }
        })
    },
    getCurrencies: function () {
      this.loading = true
      axios.get(process.env.VUE_APP_API_ROOT + '/v1/currencies')
        .then(resp => {
          console.log(resp.data)
          this.loading = false
          if (resp.data.status === 'success') {
            for (var i in resp.data.data) {
              if (resp.data.data[i].currencyCode === this.currencyCode) {
                resp.data.data[i].exchangeRateToBase = this.exchangeRateToBase
              }
            }
            this.currencies = resp.data.data
          } else {
            console.log('unable to load currencies: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + this.$route.fullPath)
            } else if (error.response.status === 403) {
              this.showAlert(error)
            }
            this.loading = false
          }
        })
    },
    changeCurrency: function (currencyCode) {
      console.log('changeCurrency: ' + currencyCode)
      for (var i in this.currencies) {
        if (this.currencies[i].currencyCode === currencyCode) {
          this.currencyDecimalSign = this.currencies[i].decimalSign
          this.currencyDecimals = this.currencies[i].decimals
          this.currencySign = this.currencies[i].sign
          this.exchangeRateToBase = this.currencies[i].exchangeRateToBase

          // update item price
          for (var j in this.orderItems) {
            this.orderItems[j].unitPrice = this.orderItems[j].unitPriceInBase / this.exchangeRateToBase
            this.orderItems[j].shippingSubsidyAmount = this.orderItems[j].shippingSubsidyAmountInBase / this.exchangeRateToBase
          }

          // update shipping cost
          for (var k in this.routing) {
            this.routing[k].deliveryCostBeforeSubsidy = this.routing[k].deliveryCostBeforeSubsidyInBase / this.exchangeRateToBase
            this.routing[k].shippingSubsidy = this.routing[k].shippingSubsidyInBase / this.exchangeRateToBase
            this.routing[k].deliveryCost = this.routing[k].deliveryCostInBase / this.exchangeRateToBase
            this.routing[k].deliveryCostOri = this.routing[k].deliveryCostOriInBase / this.exchangeRateToBase
            this.routing[k].importTariff = this.routing[k].importTariffInBase / this.exchangeRateToBase
            for (var l in this.routing[k].shippingRates) {
              this.routing[k].shippingRates[l].cost.valueBeforeSubsidy = this.routing[k].shippingRates[l].cost.valueBeforeSubsidyInBase / this.exchangeRateToBase
              this.routing[k].shippingRates[l].cost.subsidy = this.routing[k].shippingRates[l].cost.subsidyInBase / this.exchangeRateToBase
              this.routing[k].shippingRates[l].cost.value = this.routing[k].shippingRates[l].cost.valueInBase / this.exchangeRateToBase
              this.routing[k].shippingRates[l].name = this.generateCourierName(this.routing[k].shippingRates[l].courierName, this.routing[k].shippingRates[l].raw)
            }
          }

          break
        }
      }
    },
    onFilePicked: function (e) {
      const files = e.target.files
      if (files[0] !== undefined) {
        if (files[0].name.lastIndexOf('.') <= 0) {
          return
        }
        const fr = new FileReader()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          this.addItemFiles.push({
            productParamId: e.srcElement.name,
            localUrl: fr.result,
            fileContent: files[0] // this is the file content that can be sent to server...
          })
        })
      }
    },
    uploadFile: async function (file) {
      let formData = new FormData()
      formData.append('file', file, file.name)
      var resultUrl = ''
      await axios.post(process.env.VUE_APP_API_ROOT + '/v1/sales/upload',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      )
        .then(resp => {
          if (resp.data.status === 'success') {
            this.loading = false
            var url = resp.data.data.url
            console.log(url)
            resultUrl = url
          } else {
            window.alert('unable to upload file: ' + resp.data.message)
            this.loading = false
          }
        })
        .catch(function (error) {
          if (error.response) {
            window.alert(error.response.status)
          }
          this.loading = false
        })

      if (resultUrl.length > 0) {
        return resultUrl
      } else {
        return false
      }
    },
    sumDeliveryCost: function () {
      var total = 0
      for (var i in this.routing) {
        if (typeof this.routing[i].deliveryCost !== 'undefined') {
          total += this.routing[i].deliveryCost
        }
      }
      this.deliveryCost = total
    },
    sumImportTariff: function () {
      var total = 0
      for (var i in this.routing) {
        if (typeof this.routing[i].importTariff !== 'undefined') {
          total += this.routing[i].importTariff
        }
      }
      this.totalImportTariff = total
    },
    formatSkuQtyPricing: function (qtyPricingArray) {
      var result = []
      for (var i in qtyPricingArray) {
        result.push({
          qty: qtyPricingArray[i].qty,
          price: qtyPricingArray[i].priceInBase
        })
      }
      return result
    },
    skuWeight: function (product, sku) {
      for (var i in product.skus) {
        if (product.skus[i].sku === sku) {
          // sku weight is authoritative; 0 means virtual item. product.weight is only
          // the lowest weight among the product's SKUs, so it can't be used here.
          return (typeof product.skus[i].weight !== 'undefined' && product.skus[i].weight !== null
            ? Number(product.skus[i].weight)
            : Number(product.weight))
        }
      }
      return Number(product.weight)
    },
    clickAddItem: function (productIndex) {
      if (this.productListItems[productIndex].skus.length > 1) {
        this.showAddItemDialog(productIndex)
      } else if (this.productListItems[productIndex].params.length > 0) {
        this.showAddItemDialog(productIndex)
      } else {
        // can add directly
        this.addItem({
          image: this.productListItems[productIndex].image,
          images: this.productListItems[productIndex].images,
          itemParams: [],
          name: this.productListItems[productIndex].name,
          options: [],
          productId: this.productListItems[productIndex].productId,
          qty: 1,
          remarks: '',
          sku: this.productListItems[productIndex].skus[0].sku,
          currentRetailQtyPricingInBase: this.formatSkuQtyPricing(this.productListItems[productIndex].skus[0].retailQtyPricing),
          sellerUserId: this.productListItems[productIndex].sellerUserId,
          storeCountryId: this.productListItems[productIndex].storeCountryId,
          storeCountryName: this.productListItems[productIndex].storeCountryName,
          storeName: this.productListItems[productIndex].storeName,
          storeType: this.productListItems[productIndex].storeType,
          storeParentId: this.productListItems[productIndex].storeParentId,
          storeParentName: this.productListItems[productIndex].storeParentName,
          storeParentType: this.productListItems[productIndex].storeParentType,
          unitPrice: this.productListItems[productIndex].retailPriceInBase / this.exchangeRateToBase,
          unitPriceInBase: this.productListItems[productIndex].retailPriceInBase,
          unitWeight: this.skuWeight(this.productListItems[productIndex], this.productListItems[productIndex].skus[0].sku),
          shippingSubsidies: this.productListItems[productIndex].shippingSubsidies
        })
      }
    },
    showAddItemDialog: function (productIndex) {
      this.$refs.frmAddItem.reset()
      this.addItemFiles = []
      this.addItemProductIndex = productIndex
      this.addItemSkus = this.productListItems[productIndex].skus
      var i, j
      var params = []
      params = this.deepCopy(this.productListItems[productIndex].params)
      for (i in params) {
        if (params[i].type === 'select') {
          for (j in params[i].selectionItems) {
            params[i].selectionItems[j].selectionDisplayName = params[i].selectionItems[j].selectionName + ' (' + this.currencySign + this.formatPrice(params[i].selectionItems[j].priceInBase / this.exchangeRateToBase, this.currencyDecimals, this.currencyDecimalSign) + ')'
          }
        }
      }

      this.addItemParams = params
      if (this.addItemSkus.length === 1) {
        this.cboAddItemSku = this.addItemSkus[0].sku
      } else {
        this.cboAddItemSku = ''
      }
      this.txtAddItemParams = []
      for (i in this.productListItems[productIndex].params) {
        if (this.productListItems[productIndex].params[i].type === 'text' || this.productListItems[productIndex].params[i].type === 'file') {
          this.txtAddItemParams.push({
            name: this.productListItems[productIndex].params[i].name,
            value: ''
          })
        } else if (this.productListItems[productIndex].params[i].type === 'select') {
          if (this.productListItems[productIndex].params[i].isMultipleSelection === '0') {
            this.txtAddItemParams.push({
              name: this.productListItems[productIndex].params[i].name,
              selections: [{
                name: ''
              }]
            })
          } else {
            this.txtAddItemParams.push({
              name: this.productListItems[productIndex].params[i].name,
              selections: []
            })
          }
        }
      }
      this.addItemDialog = true
      this.frmAddItemValid = false
      this.$refs.frmAddItem.validate()
    },
    addItemFromDialog: async function () {
      if (this.cboAddItemSku.length === 0) {
        window.alert('Please select product SKU')
        return false
      }

      // get options
      this.loading = true
      var options = []
      var targetItem = this.deepCopy(this.productListItems[this.addItemProductIndex])
      var productImage = targetItem.image
      var i, j, k, selectionName
      var targetItemQtyPricing = []
      var targetItemPriceInBase = 0
      var targetItemWeight = this.skuWeight(targetItem, this.cboAddItemSku)

      for (i in targetItem.skus) {
        if (targetItem.skus[i].sku === this.cboAddItemSku) {
          targetItemPriceInBase = targetItem.skus[i].retailPriceInBase
          targetItemQtyPricing = targetItem.skus[i].retailQtyPricing
          options = this.deepCopy(targetItem.skus[i].options)

          // inject sku image if available
          if (targetItem.skus[i].productImageId.length > 0) {
            productImage = targetItem.skus[i].imageSmallUrl
          }
          break
        }
      }

      var paramPriceInBase = 0
      var paramWeight = 0
      for (i in targetItem.params) {
        // inject price into params selections
        if (targetItem.params[i].type === 'select') {
          if (targetItem.params[i].isMultipleSelection === '1') {
            // find prices for each selection
            for (j in targetItem.params[i].selectionItems) {
              for (k in this.txtAddItemParams[i].selections) {
                if (typeof this.txtAddItemParams[i].selections[k] === 'string') {
                  selectionName = this.txtAddItemParams[i].selections[k]
                  if (targetItem.params[i].selectionItems[j].selectionName === selectionName) {
                    this.txtAddItemParams[i].selections[k] = {
                      name: selectionName,
                      price: targetItem.params[i].selectionItems[j].priceInBase / this.exchangeRateToBase,
                      priceInBase: targetItem.params[i].selectionItems[j].priceInBase,
                      weight: targetItem.params[i].selectionItems[j].weight
                    }
                    paramPriceInBase += Number(this.txtAddItemParams[i].selections[k].priceInBase)
                    paramWeight += Number(this.txtAddItemParams[i].selections[k].weight)

                    // inject param image if available
                    if (targetItem.params[i].selectionItems[j].productImageId.length > 0) {
                      productImage = targetItem.params[i].selectionItems[j].imageSmallUrl
                    }
                  }
                }
              }
            }
          } else if (targetItem.params[i].isMultipleSelection === '0') {
            // find prices for each selection
            for (j in targetItem.params[i].selectionItems) {
              for (k in this.txtAddItemParams[i].selections) {
                console.log(targetItem.params[i].selectionItems[j].selectionName + '===' + this.txtAddItemParams[i].selections[k].name)
                if (targetItem.params[i].selectionItems[j].selectionName === this.txtAddItemParams[i].selections[k].name) {
                  this.txtAddItemParams[i].selections[k].price = targetItem.params[i].selectionItems[j].price
                  this.txtAddItemParams[i].selections[k].priceInBase = targetItem.params[i].selectionItems[j].priceInBase
                  this.txtAddItemParams[i].selections[k].weight = targetItem.params[i].selectionItems[j].weight
                  paramPriceInBase += Number(this.txtAddItemParams[i].selections[k].priceInBase)
                  paramWeight += Number(this.txtAddItemParams[i].selections[k].weight)

                  // inject param image if available
                  if (targetItem.params[i].selectionItems[j].productImageId.length > 0) {
                    productImage = targetItem.params[i].selectionItems[j].imageSmallUrl
                  }
                  break
                }
              }
            }
          }
        } else if (targetItem.params[i].type === 'file') {
          // upload file
          var isFileFound = false
          for (j in this.addItemFiles) {
            if (this.addItemFiles[j].productParamId === targetItem.params[i].productParamId) {
              console.log(this.addItemFiles[j])
              isFileFound = true
              break
            }
          }
          if (isFileFound) {
            let fileUrl = await this.uploadFile(this.addItemFiles[j].fileContent)
            this.txtAddItemParams[i].value = fileUrl
          } else {
            this.loading = false
            window.alert('Invalid uploaded file')
            return false
          }
        }
      }
      console.log(targetItem.params)
      console.log('param price in base: ' + paramPriceInBase)

      // add into order
      this.addItem({
        image: productImage,
        images: targetItem.images,
        itemParams: this.deepCopy(this.txtAddItemParams),
        name: targetItem.name,
        options: options,
        productId: targetItem.productId,
        qty: 1,
        remarks: '',
        sku: this.cboAddItemSku,
        currentRetailQtyPricingInBase: this.formatSkuQtyPricing(targetItemQtyPricing),
        sellerUserId: targetItem.sellerUserId,
        storeCountryId: targetItem.storeCountryId,
        storeCountryName: targetItem.storeCountryName,
        storeName: targetItem.storeName,
        storeType: targetItem.storeType,
        storeParentId: targetItem.storeParentId,
        storeParentName: targetItem.storeParentName,
        storeParentType: targetItem.storeParentType,
        unitPrice: (targetItemPriceInBase + paramPriceInBase) / this.exchangeRateToBase,
        unitPriceInBase: targetItemPriceInBase + paramPriceInBase,
        unitWeight: targetItemWeight + paramWeight,
        shippingSubsidies: targetItem.shippingSubsidies
      })
      this.addItemDialog = false
      this.loading = false
    },
    addItem: function (data) {
      if (typeof data.sku === 'undefined' || data.sku === '') {
        window.alert('Failed to add item: SKU required')
        return false
      }
      if (typeof data.itemParams === 'undefined') {
        window.alert('Failed to add item: Item params required')
        return false
      }
      if (typeof data.qty === 'undefined' || data.qty <= 0) {
        window.alert('Failed to add item: Qty required')
        return false
      }
      for (var i in this.orderItems) {
        if (this.orderItems[i].sku === data.sku) {
          var json1, json2
          json1 = '[]'
          json2 = '[]'
          if (Array.isArray(this.orderItems[i].itemParams)) {
            json1 = JSON.stringify(this.orderItems[i].itemParams)
          }
          if (Array.isArray(data.itemParams)) {
            json2 = JSON.stringify(data.itemParams)
          }
          console.log('index: ' + i + ', json1: ' + json1)
          console.log('index: ' + i + ', json2: ' + json2)
          if ((json1 === 'null' || json1 === '[]') && (json2 === 'null' || json2 === '[]')) {
            // both empty, found inside order
            this.moveItemToLast(i)
            this.addItemDialog = false
            this.searchProductDialog = false
            return true
          } else if (json1 === json2) {
            // json comparison same, item found inside order
            this.moveItemToLast(i)
            this.addItemDialog = false
            this.searchProductDialog = false
            return true
          }
        }
      }
      this.orderItems.push({
        image: data.image,
        images: data.images,
        itemParams: (data.itemParams.length > 0 ? data.itemParams : null),
        name: data.name,
        options: data.options,
        productId: data.productId,
        qty: data.qty,
        remarks: data.remarks,
        sku: data.sku,
        currentRetailQtyPricingInBase: data.currentRetailQtyPricingInBase,
        sellerUserId: data.sellerUserId,
        shipToUserId: (data.storeParentId && data.storeParentId.length > 0 && data.unitWeight > 0 ? data.storeParentId : ''),
        storeCountryId: data.storeCountryId,
        storeCountryName: data.storeCountryName,
        storeName: data.storeName,
        storeType: data.storeType,
        storeParentId: data.storeParentId,
        storeParentName: data.storeParentName,
        storeParentType: data.storeParentType,
        unitPrice: data.unitPrice,
        unitPriceInBase: data.unitPriceInBase,
        unitWeight: data.unitWeight,
        totalPrice: data.qty * data.unitPrice,
        shippingSubsidies: (typeof data.shippingSubsidies !== 'undefined' ? data.shippingSubsidies : [])
      })
      this.addItemDialog = false
      this.searchProductDialog = false
    },
    moveItemToLast: function (itemIndex) {
      var newItems = []
      for (var i in this.orderItems) {
        if (i !== itemIndex) {
          newItems.push(this.orderItems[i])
        }
      }
      newItems.push(this.orderItems[itemIndex])
      this.orderItems = newItems
    },
    deleteItem: function (itemIndex) {
      this.orderItems.splice(itemIndex, 1)
    },
    generateShippingQtyDropdown: function (qty, unit) {
      var result = []
      for (var i = qty; i >= 0; i--) {
        result.push(
          {
            caption: i + ' ' + unit,
            value: i
          })
      }
      return result
    },
    useAddress: function (addressIndex, billingOrShipping) {
      if (addressIndex >= this.addresses.length) {
        window.alert('Invalid address to use')
      }

      if (billingOrShipping === 'billing') {
        this.billingProvinces = []
        this.billingCities = []
        if (this.addresses[addressIndex].provinceId.length > 0) {
          this.clickCountry('billing', this.addresses[addressIndex].countryId)
        }
        if (this.addresses[addressIndex].cityId.length > 0) {
          this.clickProvince('billing', this.addresses[addressIndex].provinceId, this.addresses[addressIndex].cityId)
        }
        this.billingTitle = this.addresses[addressIndex].title
        this.billingFirstName = this.addresses[addressIndex].firstName
        this.billingLastName = this.addresses[addressIndex].lastName
        this.billingCompany = this.addresses[addressIndex].company
        this.billingAddress = this.addresses[addressIndex].address
        this.billingPostCode = this.addresses[addressIndex].postCode
        this.billingCityId = this.addresses[addressIndex].cityId
        this.billingCityName = this.addresses[addressIndex].cityName
        this.billingProvinceId = this.addresses[addressIndex].provinceId
        this.billingProvinceName = this.addresses[addressIndex].provinceName
        this.billingCountryId = this.addresses[addressIndex].countryId
        this.billingCountryName = this.addresses[addressIndex].countryName
        this.billingPhone = this.addresses[addressIndex].phone
        this.billingTaxId = this.addresses[addressIndex].taxId
        this.billingTaxIdLocalName = this.addresses[addressIndex].taxIdLocalName
        this.billingEmail = this.loginEmail
      } else if (billingOrShipping === 'shipping') {
        this.shippingProvinces = []
        this.shippingCities = []
        this.shippingIsPinpointRequired = false
        if (this.addresses[addressIndex].provinceId.length > 0) {
          this.clickCountry('shipping', this.addresses[addressIndex].countryId)
        }
        if (this.addresses[addressIndex].cityId.length > 0) {
          this.clickProvince('shipping', this.addresses[addressIndex].provinceId, this.addresses[addressIndex].cityId)
        }
        this.shippingTitle = this.addresses[addressIndex].title
        this.shippingFirstName = this.addresses[addressIndex].firstName
        this.shippingLastName = this.addresses[addressIndex].lastName
        this.shippingCompany = this.addresses[addressIndex].company
        this.shippingAddress = this.addresses[addressIndex].address
        this.shippingPostCode = this.addresses[addressIndex].postCode
        this.shippingCityId = this.addresses[addressIndex].cityId
        this.shippingCityName = this.addresses[addressIndex].cityName
        this.shippingProvinceId = this.addresses[addressIndex].provinceId
        this.shippingProvinceName = this.addresses[addressIndex].provinceName
        this.shippingCountryId = this.addresses[addressIndex].countryId
        this.shippingCountryName = this.addresses[addressIndex].countryName
        this.shippingPhone = this.addresses[addressIndex].phone
        this.shippingTaxId = this.addresses[addressIndex].taxId
        this.shippingTaxIdLocalName = this.addresses[addressIndex].taxIdLocalName
        this.shippingEmail = this.addresses[addressIndex].email
        this.shippingLatitude = this.addresses[addressIndex].latitude
        this.shippingLongitude = this.addresses[addressIndex].longitude
      }
    },
    showAddressDialog: function (billingOrShipping) {
      this.addressDialogTarget = billingOrShipping
      this.newAddressDialog = false
      this.listAddressDialog = true
      this.getAddresses()
    },
    showNewAddressDialog: function () {
      this.$refs.frmNewAddress.reset()
      this.frmNewAddressValid = false
      this.listAddressDialog = false
      this.newAddressDialog = true
    },
    getAddresses: function () {
      this.loading = true
      axios.get(process.env.VUE_APP_API_ROOT + '/v1/user/' + this.userId + '/addresses')
        .then(resp => {
          console.log(resp.data)
          this.loading = false
          if (resp.data.status === 'success') {
            this.addresses = resp.data.data
          } else {
            console.log('unable to load addresses: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + this.$route.fullPath)
            } else if (error.response.status === 403) {
              this.showAlert(error)
            }
            this.loading = false
          }
        })
    },
    addAddress () {
      if (this.$refs.frmNewAddress.validate()) {
        this.loading = true
        var data = {
          userId: this.userId,
          title: this.cboTitle,
          firstName: this.txtFirstName,
          lastName: this.txtLastName,
          company: this.txtCompany,
          address: this.txtAddress,
          postCode: this.txtPostCode,
          cityName: this.txtCityName,
          provinceName: this.txtProvinceName,
          countryId: this.cboCountryId,
          phone: this.txtPhone,
          taxId: this.txtTaxId,
          email: this.txtEmail,
          latitude: this.latitude,
          longitude: this.longitude
        }

        if (this.isValidateProvince) {
          data.provinceId = this.cboProvinceId
          data.provinceName = null
        }

        if (this.isValidateCity) {
          data.cityId = this.cboCityId
          data.cityName = null
        }

        axios.post(process.env.VUE_APP_API_ROOT + '/v1/user/address', data, {
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(resp => {
            this.loading = false
            console.log(resp.data)
            if (resp.data.status === 'success') {
              this.showAddressDialog(this.addressDialogTarget)
            } else {
              window.alert(resp.data.message)
            }
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + this.$route.fullPath)
              } else if (error.response.status === 403) {
                this.showAlert(error)
              }
              this.loading = false
            }
          })
      }
    },
    getCategories: function () {
      axios.get(process.env.VUE_APP_API_ROOT + '/v1/categories')
        .then(resp => {
          console.log(resp.data)
          if (resp.data.status === 'success') {
            var categories = [
              {
                name: 'All',
                categoryId: ''
              }
            ]
            var result = this.generateCategoryListRecursive(resp.data.data, categories, 0)
            this.categories = this.categories.concat(result)
          } else {
            console.log('unable to load categories: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + this.$route.fullPath)
            } else if (error.response.status === 403) {
              this.showAlert(error)
            }
          }
        })
    },
    generateCategoryListRecursive: function (inputCategories, output, level) {
      var strPad = ''
      for (var j = 0; j < level; j++) {
        strPad = strPad + '----'
      }
      for (var i = 0; i < inputCategories.length; i++) {
        inputCategories[i].level = level
        inputCategories[i].name = strPad + ' ' + inputCategories[i].name
        output.push(inputCategories[i])
        if (inputCategories[i].childs.length > 0) {
          output = this.generateCategoryListRecursive(inputCategories[i].childs, output, level + 1)
        }
      }
      return output
    },
    getSellers: function () {
      axios.get(process.env.VUE_APP_API_ROOT + '/v1/users?type=seller,virtual,franchise,branch&limit=100')
        .then(resp => {
          console.log(resp.data)
          if (resp.data.status === 'success') {
            this.sellers = resp.data.data
          } else {
            console.log('unable to load sellers: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + this.$route.fullPath)
            } else if (error.response.status === 403) {
              this.showAlert(error)
            }
          }
        })
    },
    getProducts: function (categoryId = '', name = '', seller = '', sort = '', offset = 0) {
      var _this = this
      var promise = new Promise(function (resolve, reject) {
        _this.loading = true
        axios.get(process.env.VUE_APP_API_ROOT + '/v1/products?category_id=' + categoryId + '&name=' + encodeURIComponent(name) + '&seller=' + seller + '&sort=' + sort + '&offset=' + offset + '&limit=8')
          .then(resp => {
            _this.loading = false
            console.log(resp.data)
            if (resp.data.status === 'success') {
              for (var c in resp.data.data) {
                if (resp.data.data[c].images.length > 0) {
                  resp.data.data[c].image = resp.data.data[c].images[0].smallUrl
                } else {
                  resp.data.data[c].image = ''
                }
              }
              _this.productListItems = resp.data.data
              _this.productListLimit = resp.data.limit
              _this.productListOffset = resp.data.offset
              _this.productListTotal = resp.data.total

              this.$nextTick(() => {
                this.$refs.productListDiv.scrollTop = 0
              })
            } else {
              console.log('unable to load products: ' + resp.data.message)
            }
            resolve()
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + _this.$route.fullPath)
                reject(error.response.status)
              } else if (error.response.status === 403) {
                _this.showAlert(error)
                reject(error.response.status)
              }
              _this.loading = false
            }
          })
      })

      return promise
    },
    getUser: function (loginEmail) {
      this.loading = true
      axios.get(process.env.VUE_APP_API_ROOT + '/v1/users?login_email=' + loginEmail)
        .then(resp => {
          console.log(resp.data)
          this.loading = false
          if (resp.data.status === 'success' && resp.data.total === 1) {
            this.userId = resp.data.data[0].userId
          } else {
            window.alert('Invalid customer email')
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + this.$route.fullPath)
            } else if (error.response.status === 403) {
              this.showAlert(error)
            }
          }
          this.loading = false
        })
    },
    getPaymentMethods: function () {
      axios.get(process.env.VUE_APP_API_ROOT + '/v1/payment/methods')
        .then(resp => {
          console.log(resp.data)
          if (resp.data.status === 'success') {
            this.paymentMethods = resp.data.data
          } else {
            console.log('unable to load payment methods: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + this.$route.fullPath)
            } else if (error.response.status === 403) {
              this.showAlert(error)
            }
          }
        })
    },
    clickCountry: function (formName, countryId) {
      var taxIdRules = []
      var taxIdLocalName = ''
      var isTaxIdRequired = false
      var isValidateProvince = false
      var isValidateCity = false
      for (var j in this.countries) {
        if (this.countries[j].countryId === countryId) {
          console.log(this.countries[j])
          if (this.countries[j].isTaxIdCompulsory === '1') {
            taxIdRules = [v => !!v || 'Tax ID is required']
            isTaxIdRequired = true
          }
          taxIdLocalName = this.countries[j].taxIdLocalName
          isValidateProvince = (this.countries[j].isValidateProvince === '1')
          isValidateCity = (this.countries[j].isValidateCity === '1')
          break
        }
      }
      if (formName === 'billing') {
        this.isValidateBillingProvince = isValidateProvince
        this.isValidateBillingCity = isValidateCity
        this.billingProvinces = []
        this.billingCities = []
        this.billingTaxIdRules = taxIdRules
        this.billingTaxIdLocalName = taxIdLocalName
        this.isBillingTaxIdRequired = isTaxIdRequired
        if (isValidateProvince === false) {
          this.billingProvinceId = ''
        }
        if (isValidateCity === false) {
          this.billingCityId = ''
        }
        if (this.billingProvinceId.length > 0 && this.billingCityId.length > 0 && isValidateProvince === true) {
          this.clickProvince('billing', this.billingProvinceId)
        }
      } else if (formName === 'shipping') {
        this.isValidateShippingProvince = isValidateProvince
        this.isValidateShippingCity = isValidateCity
        this.shippingProvinces = []
        this.shippingCities = []
        this.shippingTaxIdRules = taxIdRules
        this.shippingTaxIdLocalName = taxIdLocalName
        this.isShippingTaxIdRequired = isTaxIdRequired
        if (isValidateProvince === false) {
          this.shippingProvinceId = ''
        }
        if (isValidateCity === false) {
          this.shippingCityId = ''
        }
        if (this.shippingProvinceId.length > 0 && this.shippingCityId.length > 0 && isValidateCity === true) {
          this.clickProvince('shipping', this.shippingProvinceId)
        }
      } else if (formName === 'address') {
        this.isValidateProvince = isValidateProvince
        this.isValidateCity = isValidateCity
        this.provinces = []
        this.cities = []
        this.taxIdRules = taxIdRules
        this.isTaxIdRequired = isTaxIdRequired
        this.taxIdLocalName = taxIdLocalName
        this.cboCityId = ''
        this.txtCityName = ''
        this.cboProvinceId = ''
        this.txtProvinceName = ''
      }

      if (isValidateProvince === true) {
        this.getProvinces(formName, countryId)
      }
    },
    clickProvince: function (formName, provinceId, cityId = '') {
      if (formName === 'billing' && this.isValidateBillingCity) {
        this.getCities(formName, provinceId, cityId)
      } else if (formName === 'shipping' && this.isValidateShippingCity) {
        this.getCities(formName, provinceId, cityId)
      } else if (formName === 'address' && this.isValidateCity) {
        this.getCities(formName, provinceId, cityId)
      }
    },
    getProvinces: function (formName, countryId) {
      this.loading = true
      axios.get(process.env.VUE_APP_API_ROOT + '/v1/geo/provinces/' + countryId)
        .then(resp => {
          console.log(resp.data)
          this.loading = false
          if (resp.data.status === 'success') {
            if (formName === 'billing') {
              this.billingProvinces = resp.data.data
            } else if (formName === 'shipping') {
              this.shippingProvinces = resp.data.data
            } else if (formName === 'address') {
              this.provinces = resp.data.data
            }
          } else {
            window.alert('unable to load provinces: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + this.$route.fullPath)
            } else if (error.response.status === 403) {
              this.showAlert(error)
            }
            this.loading = false
          }
        })
    },
    clickCity: function (formName, cityId) {
      if (formName === 'shipping') {
        for (let i in this.shippingCities) {
          if (this.shippingCities[i].cityId === cityId) {
            this.shippingIsPinpointRequired = (this.shippingCities[i].isPinpointRequired === '1')
            break
          }
        }
      } else if (formName === 'address') {
        for (let i in this.cities) {
          if (this.cities[i].cityId === cityId) {
            this.isPinpointRequired = (this.cities[i].isPinpointRequired === '1')
            break
          }
        }
      }
    },
    getCities: function (formName, provinceId, cityId = '') {
      this.loading = true
      axios.get(process.env.VUE_APP_API_ROOT + '/v1/geo/cities/' + provinceId)
        .then(resp => {
          console.log(resp.data)
          this.loading = false
          if (resp.data.status === 'success') {
            if (formName === 'billing') {
              this.billingCities = resp.data.data
            } else if (formName === 'shipping') {
              this.shippingCities = resp.data.data
            } else if (formName === 'address') {
              this.cities = resp.data.data
            }
            if (cityId.length > 0) {
              this.clickCity(formName, cityId)
            }
          } else {
            window.alert('unable to load cities: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + this.$route.fullPath)
            } else if (error.response.status === 403) {
              this.showAlert(error)
            }
            this.loading = false
          }
        })
    },
    getCountries: function () {
      axios.get(process.env.VUE_APP_API_ROOT + '/v1/geo/countries?limit=1000')
        .then(resp => {
          console.log(resp.data)
          if (resp.data.status === 'success') {
            var countries = []
            for (var i in resp.data.data) {
              countries.push({
                'countryId': resp.data.data[i].countryId,
                'countryName': resp.data.data[i].countryName,
                'isTaxIdCompulsory': resp.data.data[i].isTaxIdCompulsory,
                'taxIdLocalName': resp.data.data[i].taxIdLocalName,
                'isValidateProvince': resp.data.data[i].isValidateProvince,
                'isValidateCity': resp.data.data[i].isValidateCity
              })
            }
            this.countries = countries
          } else {
            console.log('unable to load countries: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + this.$route.fullPath)
            } else if (error.response.status === 403) {
              this.showAlert(error)
            }
          }
        })
    },
    showOverrideImportTariffDialog: function (routeIndex) {
      this.overrideShippingRouteIndex = routeIndex
      this.frmOverrideImportTariffValid = true
      if (this.currencyDecimalSign === ',') {
        this.txtNewImportTariff = this.routing[routeIndex].importTariff
      } else {
        this.txtNewImportTariff = this.formatPrice(this.routing[routeIndex].importTariff, this.currencyDecimals, this.currencyDecimalSign)
      }
      this.overrideStoreName = this.routing[routeIndex].storeName
      this.overrideStoreCountryName = this.routing[routeIndex].storeCountryName
      this.overrideImportTariffDialog = true
    },
    overrideImportTariff: function (routeIndex, newImportTariff) {
      newImportTariff = parseFloat(newImportTariff)
      if (this.routing.length > routeIndex) {
        if (newImportTariff >= 0) {
          this.routing[routeIndex].importTariff = newImportTariff
          this.routing[routeIndex].importTariffInBase = newImportTariff * this.exchangeRateToBase
        } else {
          window.alert('Invalid import duties')
        }
      } else {
        window.alert('Invalid route index')
      }

      // reset override dialog
      this.overrideImportTariffDialog = false
      this.overrideShippingRouteIndex = null
      this.frmOverrideImportTariffValid = false
      this.txtNewImportTariff = 0
      this.overrideStoreCityName = ''
      this.overrideStoreCountryName = ''
      this.sumImportTariff()
    },
    showOverrideShippingCostDialog: function (routeIndex) {
      this.overrideShippingRouteIndex = routeIndex
      this.frmOverrideShippingCostValid = true
      if (this.currencyDecimalSign === ',') {
        this.txtNewShippingCost = this.routing[routeIndex].deliveryCost
      } else {
        this.txtNewShippingCost = this.formatPrice(this.routing[routeIndex].deliveryCost, this.currencyDecimals, this.currencyDecimalSign)
      }
      this.overrideCourierName = this.routing[routeIndex].courierName
      this.overrideServiceName = this.routing[routeIndex].serviceName
      this.overrideShippingCostDialog = true
    },
    overrideShippingCost: function (routeIndex, newShippingCost) {
      newShippingCost = parseFloat(newShippingCost)
      if (this.routing.length > routeIndex) {
        if (newShippingCost >= 0) {
          var courierIdServiceCode = this.routing[routeIndex].courierIdServiceCode
          this.routing[routeIndex].deliveryCost = newShippingCost
          this.routing[routeIndex].deliveryCostInBase = newShippingCost * this.exchangeRateToBase
          var isFound = false
          for (var i in this.routing[routeIndex].shippingRates) {
            if (this.routing[routeIndex].shippingRates[i].courierIdServiceCode === courierIdServiceCode) {
              this.routing[routeIndex].shippingRates[i].cost.value = newShippingCost
              this.routing[routeIndex].shippingRates[i].cost.valueInBase = newShippingCost * this.exchangeRateToBase
              this.routing[routeIndex].shippingRates[i].name = this.routing[routeIndex].shippingRates[i].courierName + ' (' + this.routing[routeIndex].shippingRates[i].serviceName + ') - ' + this.currencySign + this.formatPrice(newShippingCost, this.currencyDecimals, this.currencyDecimalSign)
              isFound = true
              break
            }
          }
          if (!isFound) {
            window.alert('Route index not found')
          }
        } else {
          window.alert('Invalid shipping cost')
        }
      } else {
        window.alert('Invalid route index')
      }

      // reset override dialog
      this.overrideShippingCostDialog = false
      this.overrideShippingRouteIndex = null
      this.frmOverrideShippingCostValid = false
      this.txtNewShippingCost = 0
      this.overrideCourierName = ''
      this.overrideServiceName = ''
    },
    selectCourier: function (routeIndex, courierIdServiceCode) {
      for (var i in this.routing[routeIndex].shippingRates) {
        if (this.routing[routeIndex].shippingRates[i].courierIdServiceCode === courierIdServiceCode) {
          this.routing[routeIndex].courierId = this.routing[routeIndex].shippingRates[i].courierId
          this.routing[routeIndex].courierName = this.routing[routeIndex].shippingRates[i].courierName
          this.routing[routeIndex].serviceCode = this.routing[routeIndex].shippingRates[i].serviceCode

          // in selected currency
          this.routing[routeIndex].deliveryCostBeforeSubsidy = this.routing[routeIndex].shippingRates[i].cost.valueBeforeSubsidy
          this.routing[routeIndex].shippingSubsidy = this.routing[routeIndex].shippingRates[i].cost.subsidy
          this.routing[routeIndex].deliveryCost = this.routing[routeIndex].shippingRates[i].cost.value
          this.routing[routeIndex].deliveryCostOri = this.routing[routeIndex].deliveryCost

          // in base currency
          this.routing[routeIndex].deliveryCostBeforeSubsidyInBase = this.routing[routeIndex].shippingRates[i].cost.valueBeforeSubsidyInBase
          this.routing[routeIndex].shippingSubsidyInBase = this.routing[routeIndex].shippingRates[i].cost.subsidyInBase
          this.routing[routeIndex].deliveryCostInBase = this.routing[routeIndex].shippingRates[i].cost.valueInBase
          this.routing[routeIndex].deliveryCostOriInBase = this.routing[routeIndex].deliveryCostInBase
          break
        }
      }
      this.sumDeliveryCost()
    },
    generateCourierName: function (courierName, rateData) {
      console.log('generateCourierName')
      console.log(rateData)
      let customCourierName = courierName + ' (' + rateData.description + ') - ' + this.currencySign + this.formatPrice(rateData.cost.value / this.exchangeRateToBase, this.currencyDecimals, this.currencyDecimalSign)
      if (rateData.cost.subsidy > 0) {
        customCourierName += ' (' + this.currencySign + this.formatPrice(rateData.cost.valueBeforeSubsidy / this.exchangeRateToBase, this.currencyDecimals, this.currencyDecimalSign) + ' - ' + this.currencySign + this.formatPrice(rateData.cost.subsidy / this.exchangeRateToBase, this.currencyDecimals, this.currencyDecimalSign) + ' Free Shipping)'
      }

      if (rateData.distanceInKm > 0) {
        customCourierName += ' (' + rateData.distanceInKm + ' KM)'
      }

      if (typeof rateData.error !== 'undefined' && rateData.error.length > 0) {
        customCourierName += ' (' + rateData.error + ')'
      } else {
        if (rateData.type === 'local' && rateData.distanceInKm === 0) {
          customCourierName += ' (Please set pinpoint)'
        } else {
          if (rateData.isShipToCompanyOnly === '1' && this.shippingCompany.length === 0) {
            customCourierName += ' (only ship to company)'
          }
          if (rateData.packageCount > 1) {
            customCourierName += ' (' + rateData.packageCount + ' packets)'
          }
        }
      }
      return customCourierName
    },
    refreshRouting: function () {
      var i, j, k
      var _this = this
      _this.loading = true
      var items = []
      for (i in _this.orderItems) {
        if (typeof _this.orderItems[i].shippingSubsidies !== 'undefined') {
          // new item
          items.push({
            sellerUserId: _this.orderItems[i].sellerUserId,
            shipToUserId: _this.orderItems[i].shipViaSellerUserId || _this.orderItems[i].shipToUserId,
            sku: _this.orderItems[i].sku,
            paramHash: _this.orderItems[i].paramHash,
            qty: _this.orderItems[i].qty,
            unitWeight: _this.orderItems[i].unitWeight,
            price: _this.orderItems[i].unitPrice,
            priceInBase: _this.orderItems[i].unitPriceInBase,
            shippingSubsidies: _this.orderItems[i].shippingSubsidies
          })
        } else {
          // existing item from order
          items.push({
            sellerUserId: _this.orderItems[i].sellerUserId,
            shipToUserId: _this.orderItems[i].shipViaSellerUserId || _this.orderItems[i].shipToUserId,
            sku: _this.orderItems[i].sku,
            paramHash: _this.orderItems[i].paramHash,
            qty: _this.orderItems[i].qty,
            unitWeight: _this.orderItems[i].unitWeight,
            price: _this.orderItems[i].unitPrice,
            priceInBase: _this.orderItems[i].unitPriceInBase,
            shippingSubsidyCourierId: _this.orderItems[i].shippingSubsidyCourierId,
            shippingSubsidyServiceCode: _this.orderItems[i].shippingSubsidyServiceCode,
            shippingSubsidyAmountInBase: _this.orderItems[i].shippingSubsidyAmount * _this.exchangeRateToBase
          })
        }
      }

      var param = {}
      if (_this.shippingCityId.length > 0) {
        param = {
          destinationCityId: (_this.shippingCityId),
          isGetShippingRates: true
        }
        if (_this.shippingLatitude !== 0 && _this.shippingLongitude !== 0) {
          param['destinationLatitude'] = _this.shippingLatitude
          param['destinationLongitude'] = _this.shippingLongitude
        }
      } else if (_this.shippingProvinceId.length > 0) {
        param = {
          destinationProvinceId: (_this.shippingProvinceId),
          isGetShippingRates: true
        }
      } else {
        param = {
          destinationCountryId: (_this.shippingCountryId),
          isGetShippingRates: true
        }
      }
      param['items'] = items
      param['declareValuePercentage'] = _this.cboDeclareValuePercentage
      axios.post(process.env.VUE_APP_API_ROOT + '/v1/sales/routing', param, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(resp => {
          _this.loading = false
          if (resp.data.status === 'success') {
            for (i in resp.data.data) {
              resp.data.data[i].courierIdServiceCode = ''
              resp.data.data[i].importTariffInBase = resp.data.data[i].importTariff
              resp.data.data[i].importTariff = resp.data.data[i].importTariffInBase / _this.exchangeRateToBase

              for (j in _this.routing) {
                if (_this.routing[j].sellerUserId === resp.data.data[i].sellerUserId) {
                  resp.data.data[i].courierId = _this.routing[j].courierId
                  resp.data.data[i].courierName = _this.routing[j].courierName
                  resp.data.data[i].serviceCode = _this.routing[j].serviceCode
                  resp.data.data[i].serviceName = _this.routing[j].serviceName
                  resp.data.data[i].courierIdServiceCode = _this.routing[j].courierIdServiceCode
                  break
                }
              }
              var rates = []
              for (j in resp.data.data[i].shippingRates) {
                for (k in resp.data.data[i].shippingRates[j].rates) {
                  var courierIdServiceCode = resp.data.data[i].shippingRates[j].courierId + '>' + resp.data.data[i].shippingRates[j].rates[k].service
                  // inject delivery cost
                  if (resp.data.data[i].courierIdServiceCode === courierIdServiceCode) {
                    // in selected currency
                    resp.data.data[i].deliveryCostBeforeSubsidy = resp.data.data[i].shippingRates[j].rates[k].cost.valueBeforeSubsidy / _this.exchangeRateToBase
                    resp.data.data[i].shippingSubsidy = resp.data.data[i].shippingRates[j].rates[k].cost.subsidy / _this.exchangeRateToBase
                    resp.data.data[i].deliveryCost = resp.data.data[i].shippingRates[j].rates[k].cost.value / _this.exchangeRateToBase
                    resp.data.data[i].deliveryCostOri = resp.data.data[i].deliveryCost

                    // in base currency
                    resp.data.data[i].deliveryCostBeforeSubsidyInBase = resp.data.data[i].shippingRates[j].rates[k].cost.valueBeforeSubsidy
                    resp.data.data[i].shippingSubsidyInBase = resp.data.data[i].shippingRates[j].rates[k].cost.subsidy
                    resp.data.data[i].deliveryCostInBase = resp.data.data[i].shippingRates[j].rates[k].cost.value
                    resp.data.data[i].deliveryCostOriInBase = resp.data.data[i].deliveryCostInBase
                  }

                  rates.push({
                    courierIdServiceCode: courierIdServiceCode,
                    name: _this.generateCourierName(resp.data.data[i].shippingRates[j].courierName, resp.data.data[i].shippingRates[j].rates[k]),
                    courierId: resp.data.data[i].shippingRates[j].courierId,
                    courierName: resp.data.data[i].shippingRates[j].courierName,
                    countryId: resp.data.data[i].shippingRates[j].storeCountryId,
                    serviceCode: resp.data.data[i].shippingRates[j].rates[k].service,
                    serviceName: resp.data.data[i].shippingRates[j].rates[k].description,
                    packageCount: resp.data.data[i].shippingRates[j].rates[k].packageCount,
                    weightLimit: resp.data.data[i].shippingRates[j].rates[k].weightLimit,
                    raw: resp.data.data[i].shippingRates[j].rates[k],
                    cost: {
                      valueBeforeSubsidy: resp.data.data[i].shippingRates[j].rates[k].cost.valueBeforeSubsidy / _this.exchangeRateToBase,
                      subsidy: resp.data.data[i].shippingRates[j].rates[k].cost.subsidy / _this.exchangeRateToBase,
                      value: resp.data.data[i].shippingRates[j].rates[k].cost.value / _this.exchangeRateToBase,
                      valueBeforeSubsidyInBase: resp.data.data[i].shippingRates[j].rates[k].cost.valueBeforeSubsidy,
                      subsidyInBase: resp.data.data[i].shippingRates[j].rates[k].cost.subsidy,
                      valueInBase: resp.data.data[i].shippingRates[j].rates[k].cost.value,
                      etd: resp.data.data[i].shippingRates[j].rates[k].cost.etd,
                      note: resp.data.data[i].shippingRates[j].rates[k].cost.note
                    }
                  })
                }
              }
              rates.sort(function (a, b) {
                // sort by package count, then by shipping cost
                return a.packageCount - b.packageCount || a.cost.value - b.cost.value
              })
              resp.data.data[i].shippingRates = rates
            }
            _this.routing = resp.data.data
          } else {
            _this.routing = []
            window.alert('Unable to refresh routing: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(_this)
            _this.loading = false
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + _this.$route.fullPath)
            }
          }
        })
    },
    recalculateImportTariff: function () {
      for (const route of this.routing) {
        let totalItemAmountInBase = 0
        for (const item of this.orderItems) {
          if (item.sellerUserId === route.sellerUserId || (route.shipForSellers && route.shipForSellers.some(seller => seller.sellerUserId === item.sellerUserId))) {
            if (item.unitWeight > 0 && item.qty > 0) {
              totalItemAmountInBase += item.qty * item.unitPriceInBase
            }
          }
        }
        const declareAmountInBase = totalItemAmountInBase * (this.cboDeclareValuePercentage / 100)

        let importTariffInBase = 0
        const matchingTariff = this.importTariffs.find(
          tariff =>
            tariff.originCountryId === route.storeCountryId &&
            tariff.destinationCountryId === this.shippingCountryId
        )
        if (matchingTariff) {
          if (declareAmountInBase >= matchingTariff.minimumAmountInBase) {
            importTariffInBase = (declareAmountInBase * (matchingTariff.tariffPercentage / 100)) + matchingTariff.tariffAmountInBase
          }
        }
        route.importTariffInBase = importTariffInBase
        route.importTariff = importTariffInBase / this.exchangeRateToBase
      }
    },
    getSalesOrderDetails: function () {
      if (this.salesOrderNo) {
        var _this = this
        _this.loading = true
        axios.get(process.env.VUE_APP_API_ROOT + '/v1/sales/' + _this.salesOrderNo)
          .then(resp => {
            this.loading = false
            if (resp.data.status === 'success') {
              this.userId = resp.data.data.userId
              this.loginEmail = resp.data.data.loginEmail
              this.invoiceNo = resp.data.data.invoiceNo
              this.currencyCode = resp.data.data.currencyCode
              this.currencySign = resp.data.data.currencySign
              this.currencyDecimals = resp.data.data.currencyDecimals
              this.currencyDecimalSign = resp.data.data.currencyDecimalSign
              this.exchangeRateToBase = resp.data.data.exchangeRateToBase
              this.createdDateTime = resp.data.data.createdDateTime
              this.expiryDateTime = resp.data.data.expiryDateTime
              this.billingTitle = resp.data.data.billingTitle
              this.billingFirstName = resp.data.data.billingFirstName
              this.billingLastName = resp.data.data.billingLastName
              this.billingCompany = resp.data.data.billingCompany
              this.billingPhone = resp.data.data.billingPhone
              this.billingAddress = resp.data.data.billingAddress
              this.billingPostCode = resp.data.data.billingPostCode
              this.billingCityId = resp.data.data.billingCityId
              this.billingCityName = resp.data.data.billingCityName
              this.billingProvinceId = resp.data.data.billingProvinceId
              this.billingProvinceName = resp.data.data.billingProvinceName
              this.billingCountryId = resp.data.data.billingCountryId
              this.billingCountryName = resp.data.data.billingCountryName
              this.billingTaxId = resp.data.data.billingTaxId
              this.billingEmail = resp.data.data.loginEmail
              if (this.billingProvinceId.length > 0) {
                this.clickCountry('billing', this.billingCountryId)
              }
              if (this.billingCityId.length > 0) {
                this.clickProvince('billing', this.billingProvinceId, this.billingCityId)
              }
              this.shippingTitle = resp.data.data.shippingTitle
              this.shippingFirstName = resp.data.data.shippingFirstName
              this.shippingLastName = resp.data.data.shippingLastName
              this.shippingCompany = resp.data.data.shippingCompany
              this.shippingPhone = resp.data.data.shippingPhone
              this.shippingAddress = resp.data.data.shippingAddress
              this.shippingPostCode = resp.data.data.shippingPostCode
              this.shippingCityId = resp.data.data.shippingCityId
              this.shippingCityName = resp.data.data.shippingCityName
              this.shippingProvinceId = resp.data.data.shippingProvinceId
              this.shippingProvinceName = resp.data.data.shippingProvinceName
              this.shippingCountryId = resp.data.data.shippingCountryId
              this.shippingCountryName = resp.data.data.shippingCountryName
              this.shippingTaxId = resp.data.data.shippingTaxId
              this.shippingEmail = resp.data.data.shippingEmail
              this.shippingLatitude = resp.data.data.shippingLatitude
              this.shippingLongitude = resp.data.data.shippingLongitude
              if (this.shippingProvinceId.length > 0) {
                this.clickCountry('shipping', this.shippingCountryId)
              }
              if (this.shippingCityId.length > 0) {
                this.clickProvince('shipping', this.shippingProvinceId, this.shippingCityId)
              }
              this.orderType = resp.data.data.type
              this.orderStatus = resp.data.data.orderStatus
              this.paymentStatus = resp.data.data.paymentStatus
              this.cboPaymentMethodId = resp.data.data.paymentMethodId
              this.paidDateTime = resp.data.data.paidDateTime
              this.deliveryStatus = resp.data.data.deliveryStatus
              this.cboDeclareValuePercentage = resp.data.data.declareValuePercentage
              for (var i in resp.data.data.routing) {
                resp.data.data.routing[i].courierIdServiceCode = resp.data.data.routing[i].courierId + '>' + resp.data.data.routing[i].serviceCode
                resp.data.data.routing[i].deliveryCostOri = resp.data.data.routing[i].deliveryCost
                resp.data.data.routing[i].deliveryCostOriInBase = resp.data.data.routing[i].deliveryCostInBase
                resp.data.data.routing[i].shippingRates = [{
                  courierIdServiceCode: resp.data.data.routing[i].courierId + '>' + resp.data.data.routing[i].serviceCode,
                  name: resp.data.data.routing[i].courierName + ' - ' + resp.data.data.routing[i].serviceCode + ' - ' + resp.data.data.currencySign + this.formatPrice(resp.data.data.routing[i].deliveryCost, this.currencyDecimals, this.currencyDecimalSign) + (resp.data.data.routing[i].shippingSubsidy > 0 ? ' (' + resp.data.data.currencySign + this.formatPrice(resp.data.data.routing[i].deliveryCostBeforeSubsidy, this.currencyDecimals, this.currencyDecimalSign) + ' - ' + this.formatPrice(resp.data.data.routing[i].shippingSubsidy, this.currencyDecimals, this.currencyDecimalSign) + ' Free Shipping)' : ''),
                  courierId: resp.data.data.routing[i].courierId,
                  courierName: resp.data.data.routing[i].courierName,
                  countryId: resp.data.data.routing[i].storeCountryId,
                  serviceCode: resp.data.data.routing[i].serviceCode,
                  serviceName: resp.data.data.routing[i].serviceName,
                  cost: {
                    value: resp.data.data.routing[i].deliveryCost,
                    valueInBase: resp.data.data.routing[i].deliveryCostInBase,
                    etd: '',
                    note: ''
                  }
                }]
              }
              this.routing = resp.data.data.routing
              this.verifications = resp.data.data.verifications
              this.courierName = resp.data.data.courierName
              this.serviceName = resp.data.data.serviceName

              if (this.paymentStatus === 'none') {
                this.paymentStatusColor = 'grey darken-2'
                this.paymentStatusIcon = 'clear'
              } else if (this.paymentStatus === 'partial') {
                this.paymentStatusColor = 'orange'
                this.paymentStatusIcon = 'opacity'
              } else if (this.paymentStatus === 'pending' || this.paymentStatus === 'in-verification') {
                this.paymentStatusColor = 'orange'
                this.paymentStatusIcon = 'hourglass_empty'
              } else if (this.paymentStatus === 'paid' || this.paymentStatus === 'credit') {
                this.paymentStatusColor = 'green darken-3'
                this.paymentStatusIcon = 'done'
              } else if (this.paymentStatus === 'rejected' || this.paymentStatus === 'expired') {
                this.paymentStatusColor = 'red darken-2'
                this.paymentStatusIcon = 'clear'
              } else if (this.paymentStatus === 'chargeback') {
                this.paymentStatusColor = 'red darken-2'
                this.paymentStatusIcon = 'priority_high'
              }

              if (this.deliveryStatus === 'pending') {
                this.deliveryStatusColor = 'grey darken-2'
                this.deliveryStatusIcon = 'hourglass_empty'
              } else if (this.deliveryStatus === 'partial') {
                this.deliveryStatusColor = 'orange'
                this.deliveryStatusIcon = 'opacity'
              } else if (this.deliveryStatus === 'sent' || this.deliveryStatus === 'delivered') {
                this.deliveryStatusColor = 'green darken-3'
                this.deliveryStatusIcon = 'done'
              }

              this.events = resp.data.data.events

              for (var c = 0; c < resp.data.data.items.length; ++c) {
                if (resp.data.data.items[c].images.length > 0) {
                  resp.data.data.items[c].image = resp.data.data.items[c].images[0].smallUrl
                } else {
                  resp.data.data.items[c].image = ''
                }
                resp.data.data.items[c].totalPrice = resp.data.data.items[c].qty * resp.data.data.items[c].unitPrice
              }
              this.orderItems = []
              for (var d in resp.data.data.items) {
                if (resp.data.data.items[d].qty > 0) {
                  this.orderItems.push(resp.data.data.items[d])
                }
              }
            } else {
              console.log('unable to load sales order details: ' + resp.data.message)
            }
          })
          .catch(function (error) {
            if (error.response) {
              console.log(this)
              _this.loading = false
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + _this.$route.fullPath)
              }
            }
          })
      }
    },
    submit () {
      if (this.orderItems.length <= 0) {
        window.alert('No item in the order')
        return false
      }
      if (this.routing.length <= 0) {
        window.alert('No courier selected')
        return false
      }

      var i
      var orderData = {}
      orderData.userId = this.userId
      orderData.currencyCode = this.currencyCode
      orderData.exchangeRateToBase = this.exchangeRateToBase
      orderData.paymentMethodId = this.cboPaymentMethodId
      orderData.declareValuePercentage = this.cboDeclareValuePercentage
      orderData.billingTitle = this.billingTitle
      orderData.billingFirstName = this.billingFirstName
      orderData.billingLastName = this.billingLastName
      orderData.billingCompany = this.billingCompany
      orderData.billingAddress = this.billingAddress
      orderData.billingPostCode = this.billingPostCode
      orderData.billingCityId = this.billingCityId
      orderData.billingCityName = this.billingCityName
      orderData.billingProvinceId = this.billingProvinceId
      orderData.billingProvinceName = this.billingProvinceName
      orderData.billingCountryId = this.billingCountryId
      orderData.billingPhone = this.billingPhone
      orderData.billingTaxId = this.billingTaxId
      orderData.shippingTitle = this.shippingTitle
      orderData.shippingFirstName = this.shippingFirstName
      orderData.shippingLastName = this.shippingLastName
      orderData.shippingCompany = this.shippingCompany
      orderData.shippingAddress = this.shippingAddress
      orderData.shippingPostCode = this.shippingPostCode
      orderData.shippingCityId = this.shippingCityId
      orderData.shippingCityName = this.shippingCityName
      orderData.shippingProvinceId = this.shippingProvinceId
      orderData.shippingProvinceName = this.shippingProvinceName
      orderData.shippingCountryId = this.shippingCountryId
      orderData.shippingPhone = this.shippingPhone
      orderData.shippingTaxId = this.shippingTaxId
      orderData.shippingEmail = this.shippingEmail
      orderData.shippingLatitude = this.shippingLatitude
      orderData.shippingLongitude = this.shippingLongitude
      // orderData.remarks = this.txtRemark
      orderData.items = []
      orderData.couriers = []

      for (i in this.orderItems) {
        if (typeof this.orderItems[i].shippingSubsidies !== 'undefined') {
          // new item
          orderData.items.push({
            sellerUserId: this.orderItems[i].sellerUserId,
            shipToUserId: this.orderItems[i].shipToUserId || this.orderItems[i].shipViaSellerUserId,
            sku: this.orderItems[i].sku,
            itemParams: this.orderItems[i].itemParams,
            name: this.orderItems[i].name,
            qty: this.orderItems[i].qty,
            price: this.orderItems[i].unitPrice,
            priceInBase: this.orderItems[i].unitPriceInBase,
            unitWeight: this.orderItems[i].unitWeight,
            shippingSubsidies: this.orderItems[i].shippingSubsidies
          })
        } else {
          // existing item from order
          orderData.items.push({
            sellerUserId: this.orderItems[i].sellerUserId,
            shipToUserId: this.orderItems[i].shipToUserId || this.orderItems[i].shipViaSellerUserId,
            sku: this.orderItems[i].sku,
            itemParams: this.orderItems[i].itemParams,
            name: this.orderItems[i].name,
            qty: this.orderItems[i].qty,
            price: this.orderItems[i].unitPrice,
            priceInBase: this.orderItems[i].unitPriceInBase,
            unitWeight: this.orderItems[i].unitWeight,
            shippingSubsidyCourierId: this.orderItems[i].shippingSubsidyCourierId,
            shippingSubsidyServiceCode: this.orderItems[i].shippingSubsidyServiceCode,
            shippingSubsidyAmount: this.orderItems[i].shippingSubsidyAmount
          })
        }
      }

      for (i in this.routing) {
        orderData.couriers.push({
          sellerUserId: this.routing[i].sellerUserId,
          courierId: this.routing[i].courierId,
          serviceCode: this.routing[i].serviceCode,
          deliveryCost: this.routing[i].deliveryCost,
          importTariff: this.routing[i].importTariff
        })
      }

      if (this.salesOrderNo) { // Edit order
        this.loading = true
        axios.put(process.env.VUE_APP_API_ROOT + '/v1/sales/' + this.salesOrderNo, orderData, {
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(resp => {
            this.loading = false
            if (resp.data.status === 'success') {
              alert('Order saved')
              router.push('/order/' + this.salesOrderNo)
            } else {
              window.alert(resp.data.message)
            }
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + this.$route.fullPath)
              } else if (error.response.status === 403) {
                this.showAlert(error)
              }
              this.loading = false
            }
          })
      } else { // Create order
        orderData.type = 'custom'
        this.loading = true
        axios.post(process.env.VUE_APP_API_ROOT + '/v1/sales', orderData, {
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(resp => {
            this.loading = false
            if (resp.data.status === 'success') {
              alert('Order created')
              router.push('/order/' + resp.data.data.salesOrderNo)
            } else {
              window.alert(resp.data.message)
            }
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + this.$route.fullPath)
              } else if (error.response.status === 403) {
                this.showAlert(error)
              }
              this.loading = false
            }
          })
      }
    }
  }
}
</script>
